<template>
  <div class="contact-table pb-5" id="contact-table">
    <v-simple-table class="table-layout table-contact table-fixed">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="th-# scroll-layout-left th_checkbox" :style="'min-width: 35px; left:' + sticky_id" ref="th_id">
                {{countContactSelect}}
              <div data-v-22d75c44 class="border-bottom-table"></div>
            </th>
            <th class="th-id scroll-layout-left" :style="'min-width: 40px; left:' + sticky_checkbox + 'px'" ref="th_checkbox">
              <v-checkbox
                class="table-layout-checkbox ma-0 pa-0"
                v-model="filterForm.checkboxAll"
                @change="onChangeCheckboxAll"
              />
              <div class="border-bottom-table"></div>
            </th>
            <th
              v-for="(attribute, index) in rowAttributes"
              :key="index + '_th'"
              :class="stickyColumn.indexOf(attribute.name) > -1 ? 'scroll-layout-left th_' + attribute.name : 'th_' + attribute.name"
              :ref="'th_' + attribute.name"
              :style="stickyColumn.indexOf(attribute.name) === 0 ? 'left:' + sticky_childFullName + 'px' :
                  (stickyColumn.indexOf(attribute.name) === 1 ? 'left:' + sticky_mobile + 'px' :
                  (stickyColumn.indexOf(attribute.name) === 2 ? 'left:' + sticky_birthday + 'px' : ''))"
              v-show="statusRowAttribute(attribute.name) && checkShowAtrribute(attribute.name)"
            >
              {{attribute.title}}
              <div data-v-22d75c44 class="border-bottom-table"></div>
            </th>
            <th class="th_action">
              Thao tác
              <div data-v-22d75c44 class="border-bottom-table"></div>
            </th>
          </tr>
        </thead>
        <tbody
          class="bg-hover"
          :class="contact && contact.callingStatus ? contact.callingStatus : ''"
          :ref="`contact-row-${index}`"
          v-for="(contact, index) in contacts"
          :key="`${contact.id}_${index} + ${reRender}}`"
        >
          <tr>
            <td class="scroll-layout-left tr-numerical-order" :style="'left:' + sticky_id" :rowspan="contact.rowspan">{{index + 1 + (currentPage - 1)*limit}}</td>
            <td
              class="scroll-layout-left"
              :rowspan="contact.rowspan"
              :style="'backgroundColor:' + _.get(contact, 'contactStatus.color', '') + '; left:' + sticky_checkbox + 'px'"
            >
              <v-checkbox class="table-layout-checkbox ma-0 pa-0" v-model="contact.checkbox" />
              <div class="border-bottom-table"></div>
            </td>
            <td
              v-show="statusRowAttribute('code') && user.position != userPositions.STAFF"
              :rowspan="contact.rowspan"
            >{{ _.get(contact, 'code', '') }}
<!--              <span-->
<!--                  v-if="contact.trialStatus"-->
<!--                  class="trail-tag"-->
<!--                  :class="contact.trialStatus == 'TN' ? 'tn-tag-trial'-->
<!--                  : contact.trialStatus == 'CH' ? 'ch-tag-trial' : 'v-tag-trial'"-->
<!--              >{{ _.get(contact, 'trialStatus', '') }}</span>-->
            </td>
            <td class="scroll-layout-left" style="z-index:2;" :style="'min-width: 10rem; left:' + sticky_childFullName + 'px'" v-show="statusRowAttribute('childFullName')"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'childFullName', indexChild: 0, id: contact.childCustomer[0].editId, oldValue: contact.childCustomer[0].fullName})">
            <!-- <td class="scroll-layout-left" :style="'min-width: 10rem; left:' + sticky_childFullName + 'px'" v-show="statusRowAttribute('childFullName')"> -->
                <div class="d-flex align-center justify-space-between">
                      <div class="d-flex align-center">
                        <v-tooltip  v-if="!_.get(contact,'childCustomer[0].isMainCustomer', false) && _.get(contact,'childCustomer', []).length > 1 && _.get(contact, 'childCustomer[0].fullName', '') && checkAuthorization('contact_update')" bottom>
                          <template
                          v-slot:activator="{ on }"
                        >
                          <v-btn
                            @click="checkCanDeleteCustomer(contact.id, _.get(contact,'childCustomer[0].id',''))"
                            icon
                            small
                            color="primary"
                            v-on="on"
                          >
                            <v-icon>mdi-account-remove</v-icon>
                          </v-btn>
                        </template>
                        <span>Xoá thông tin con</span>
                      </v-tooltip>
                      <span v-if="!contact.childCustomer[0].editAttrs.childFullName">{{ _.get(contact, 'childCustomer[0].fullName', '') }}</span>
                      <!-- <input v-if="contact.childCustomer[0].editAttrs.childFullName"
                        v-bind:id="'childFullName_' + contact.childCustomer[0].editId" type="text"
                        v-model="contact.childCustomer[0].fullName" style="width: calc(100% - 30px); height: 80%; padding-left: 5px"
                        @change="onChangeAttribute(contact.childCustomer[0], 'childFullName', index, 0, contact.id)"/> -->
                      <v-text-field
                        v-if="contact.childCustomer[0].editAttrs.childFullName"
                        :id="'childFullName_' + contact.childCustomer[0].editId"
                        :value="contact.childCustomer[0].fullName"
                        color="primary"
                        label="Tên con"
                        @change="onChangeAttribute(contact.childCustomer[0], 'childFullName', index, 0, contact.id, $event)"
                      />
                    </div>
                    <div class="tool-tips-bitu ml-2" v-if="contact.childCustomer[0].isMainAccount">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            :size="size"
                            :color="color"
                            class="mx-2"
                            >
                            <img v-if="showBitu(contact.childCustomer[0].userName)" src="../../../../public/img/bitu.svg" style="width: 25px;height: 20px;object-fit:fill" alt="">
                            <p class="acc-bitu">Acc</p>
                          </div>
                        </template>
                        <span>
                          <div>Tài khoản Vuihoc: {{ contact.childCustomer[0].userName }}</div>
                          <div v-if="contact.childCustomer[0].order">Đơn tạo gần nhất: {{ formatDateToolTips(contact.childCustomer[0].order)}}</div>
                        </span>
                      </v-tooltip>
                    </div>
                </div>
            </td>
            <td class="scroll-layout-left" :style="'left:' + sticky_mobile + 'px'"
                v-show="statusRowAttribute('mobile')" :rowspan="contact.rowspan">
              {{ maskedPhoneNumber(_.get(contact, 'mobile', '')) }}
              <span v-if="contact.zuid">
                <img src = "../../../../public/img/zalo.svg" alt="Zalo" class="ml-1" style="width: 16px;height: 16px;vertical-align: middle;" />
              </span>
              <v-tooltip bottom>
                <template v-if="checkContactSources(contact.contactSources)" v-slot:activator="{ on }">
                  <v-btn
                    size="16"
                    width="20"
                    height="20"
                    class="mr-1"
                    icon
                    small
                    color="info"
                    v-on="on"
                  >
                    <v-icon size="16">mdi-facebook-messenger</v-icon>
                  </v-btn>
                </template>
                <span>Nhắn tin</span>
              </v-tooltip>
              <v-tooltip bottom v-if="contact.contactType == 'main'">
                <template v-slot:activator="{ on }">
                  <v-btn
                    size="16"
                    width="20"
                    height="20"
                    class="mr-1"
                    icon
                    small
                    color="success"
                    v-on="on"
                  >
                    <v-icon size="16">mdi-account-multiple</v-icon>
                  </v-btn>
                  </template>
                <span>Contact chính</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="contact.contactType == 'sub'">
                <template v-slot:activator="{ on }">
                  <v-btn
                    size="16"
                    width="20"
                    height="20"
                    class="mr-1"
                    icon
                    small
                    color="default"
                    v-on="on"
                  >
                    <v-icon size="16">mdi-account-multiple</v-icon>
                  </v-btn>
                  </template>
                <span>Contact phụ</span>
              </v-tooltip>
              <span class="ml-1">
                <CopyIconButton
                  v-if="isShowCopyPhoneNumber"
                  :value="_.get(contact, 'mobile', '')"
                  content-copy-success="Sao chép số điện thoại thành công!"
                  style="display: inline-block;"
                />
              </span>
            </td>
            <td class="scroll-layout-left" :style="'left:' + sticky_birthday + 'px'"
                v-show="statusRowAttribute('birthday')"
                @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'birthday', indexChild: 0, id: contact.childCustomer[0].editId, type: 'select', oldValue: contact.childCustomer[0].birthday})"
            >
            <!-- <td class="scroll-layout-left" :style="'left:' + sticky_birthday + 'px'"
                v-show="statusRowAttribute('birthday')"> -->
              <span v-if="!contact.childCustomer[0].editAttrs.birthday">{{ _.get(contact, 'childCustomer[0].birthday', '') }}</span>
              <common-select-year
                v-if="contact.childCustomer[0].editAttrs.birthday"
                v-model="contact.childCustomer[0].birthday"
                label="Năm sinh"
                @input="onChangeAttribute(contact.childCustomer[0], 'birthday', index, 0, contact.id, $event)"
              />
            </td>

            <td v-show="statusRowAttribute('birthdayDescription')"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'birthdayDescription', indexChild: 0, id: contact.childCustomer[0].editId, oldValue: contact.childCustomer[0].birthdayDescription})"
              >
              <span v-if="!contact.childCustomer[0].editAttrs.birthdayDescription">{{ _.get(contact.childCustomer[0], 'birthdayDescription', '') }}</span>
              <input v-if="contact.childCustomer[0].editAttrs.birthdayDescription"
              v-bind:id="'birthdayDescription_' + contact.childCustomer[0].editId" type="text"
              style="width: 100%; height: 80%; padding-left: 5px"
              :value="contact.childCustomer[0].birthdayDescription"
              @change="onChangeAttribute(contact.childCustomer[0], 'birthdayDescription', index, 0, contact.id, $event)"/>
            </td>
            <td v-show="statusRowAttribute('productDescription')"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'productDescription', indexChild: 0, id: contact.childCustomer[0].editId, oldValue: contact.childCustomer[0].productDescription})"
              >
              <span v-if="!contact.childCustomer[0].editAttrs.productDescription" style="word-break: break-word">{{ _.get(contact.childCustomer[0], 'productDescription', '') }}</span>
              <input v-if="contact.childCustomer[0].editAttrs.productDescription"
              v-bind:id="'productDescription_' + contact.childCustomer[0].editId" type="text"
              style="width: 100%; height: 80%; padding-left: 5px"
              :value="contact.childCustomer[0].productDescription"
              @change="onChangeAttribute(contact.childCustomer[0], 'productDescription', index, 0, contact.id, $event)"/>
                <v-tooltip bottom v-if=" _.get(contact.childCustomer[0], 'customerData.doCapacityTest', []).length == 1">
                  <template v-slot:activator="{ on }">
                    <v-btn v-if="_.get(contact.childCustomer[0], 'customerData.doCapacityTest', []).length == 1"
                           class="btn-show-modal-count-interaction"
                           :href="_.get(contact.childCustomer[0], 'customerData.doCapacityTest[0].url', '')"
                           target="_blank"
                           icon
                           small
                           color="info"
                           v-on="on"
                    >
                      <v-icon color="pink" class="icon-comment">mdi-file-document</v-icon>
                    </v-btn>
                  </template>
                  <span>Xem nhận xét kiểm tra năng lực</span>
                </v-tooltip>

                <template v-else-if="_.get(contact.childCustomer[0], 'customerData.doCapacityTest', []).length > 1">
                  <v-menu
                      :close-on-content-click="false"
                      :nudge-width="0"
                      offset-x
                  >
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                              class="btn-show-modal-count-interaction"
                              small
                              color="pink"
                              dark
                              v-bind="attrs"
                              v-on="{...tooltip, ...menu}"
                              icon
                          >
                            <v-icon color="pink" class="icon-comment">mdi-file-document</v-icon>
                          </v-btn>
                        </template>
                        <span>Xem nhận xét kiểm tra năng lực</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item
                          v-for="item in _.get(contact.childCustomer[0], 'customerData.doCapacityTest', [])"
                      >
                        <a :href="item.url" target="_blank">{{item.name}}</a>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>

                <v-tooltip bottom v-if="contact.capacityAssessmentAt">
                  <template v-slot:activator="{ on }">
                    <v-icon color="blue" class="icon-comment" v-on="on">mdi-note-text</v-icon>
                  </template>
                  <span>Thi DGNL</span><br>
                  <span>{{ contact.capacityAssessmentAt | formatDateTime }}</span>
                </v-tooltip>
            </td>
            <td v-show="statusRowAttribute('capability')"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'capability', indexChild: 0, id: contact.childCustomer[0].editId, oldValue: contact.childCustomer[0].capability})"
              >
              <span v-if="!contact.childCustomer[0].editAttrs.capability">{{ _.get(contact.childCustomer[0], 'capability', '') }}</span>
              <input v-if="contact.childCustomer[0].editAttrs.capability"
              v-bind:id="'capability_' + contact.childCustomer[0].editId" type="text"
              style="width: 100%; height: 80%; padding-left: 5px"
              :value="contact.childCustomer[0].capability"
              @change="onChangeAttribute(contact.childCustomer[0], 'capability', index, 0, contact.id, $event)"/>
            </td>

            <td
                v-show="statusRowAttribute('studyResult')"
            >
<!--              <span v-if=" _.get(contact.childCustomer[0], 'isLoading', '')">Đang cập nhật ...</span>-->
<!--              <v-icon v-if="loadingResultStudy">mdi-loading</v-icon>-->

              <v-tooltip bottom v-if=" _.get(contact.childCustomer[0], 'statusResultName', []).length">
                <template v-slot:activator="{ on }">
                  <v-btn class="btn-show-modal-study-result"
                         @click="clickShowStudyResult(contact.childCustomer[0])"
                         icon
                         small
                         color="info"
                         v-on="on"
                  >
                    <v-icon>mdi-book-open-variant</v-icon>
                  </v-btn>
                  <span class="custom-span-title-study-result pl-1">{{ _.get(contact.childCustomer[0], 'statusResultName', '') }}</span>
                </template>
                <span>Kết quả học tập</span>
              </v-tooltip>
            </td>


            <template
              v-for="(attribute, index) in rowAttributes.filter(data => data.object === 'child')"
            >
              <td
                v-show="statusRowAttribute(attribute.name)"
                :key="'coloumn_child_'+ index"
              >{{ _.get(contact, `childCustomer[0].${attribute.name}`, '') }}</td>
            </template>
            <!-- <td
              v-show="statusRowAttribute('email')"
              :rowspan="contact.rowspan"
            >{{ _.get(contact, 'email', '') }}</td> -->
            <td v-show="statusRowAttribute('email')" :rowspan="contact.rowspan"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'email', indexChild: 0, id: contact.childCustomer[0].editId, oldValue: contact.email})"
              >
              <span v-if="!contact.childCustomer[0].editAttrs.email">{{ _.get(contact, 'email', '') }}</span>
              <input v-if="contact.childCustomer[0].editAttrs.email"
              v-bind:id="'email_' + contact.childCustomer[0].editId" type="text"
              style="width: 100%; height: 80%; padding-left: 5px"
              :value="contact.email"
              @change="onChangeAttribute(contact, 'email', index, 0, contact.id, $event)"/>
            </td>
            <td
              v-show="statusRowAttribute('parentFullName')"
              :rowspan="contact.rowspan"
              style="min-width: 10rem;"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'fullName', indexChild: 0, id: contact.childCustomer[0].editId, oldValue: contact.fullName})"
              >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn @click="clickQuickView(contact)" icon small color="info" v-on="on">
                    <v-icon>mdi-alert-circle</v-icon>
                  </v-btn>
                </template>
                <span>Thông tin cơ bản</span>
              </v-tooltip>
              <span
                v-if="!contact.childCustomer[0].editAttrs.fullName"
                @click="clickContact(contact.id)"
                style="cursor: pointer;"
              >
              {{ contact.fullName === contact.mobile ?  maskedPhoneNumber(_.get(contact, 'fullName', '')) : _.get(contact, 'fullName', '') }}</span>
              <input v-if="contact.childCustomer[0].editAttrs.fullName"
                v-bind:id="'fullName_' + contact.childCustomer[0].editId" type="text"
                style="width: calc(100% - 30px); height: 80%; padding-left: 5px"
                :value="contact.fullName"
                @change="onChangeAttribute(contact, 'fullName', index, 0, contact.id, $event)"/>
            </td>
            <td
              v-show="statusRowAttribute('numberOfCall')"
              :rowspan="contact.rowspan"
              style="max-width: 20px;"
              >{{contact.numberOfCall}}
            </td>

            <td
                v-show="statusRowAttribute('numberOfCallC')"
                :rowspan="contact.rowspan"
                style="max-width: 20px;"
            >{{contact.numberOfCallC}}
            </td>

            <td
                v-show="statusRowAttribute('numberOfCallG')"
                :rowspan="contact.rowspan"
                style="max-width: 20px;"
            >{{contact.numberOfCallG}}
            </td>

            <td v-show="statusRowAttribute('detailAddress')" :rowspan="contact.rowspan"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'detailAddress', indexChild: 0, id: contact.childCustomer[0].editId, oldValue: contact.detailAddress})"
              >
              <span v-if="!contact.childCustomer[0].editAttrs.detailAddress">{{ _.get(contact, 'detailAddress', '') }}</span>
              <input v-if="contact.childCustomer[0].editAttrs.detailAddress"
              v-bind:id="'detailAddress_' + contact.childCustomer[0].editId" type="text"
              style="width: 100%; height: 80%; padding-left: 5px"
              :value="contact.detailAddress"
              @change="onChangeAttribute(contact, 'detailAddress', index, 0, contact.id, $event)"/>
              <v-tooltip bottom v-if="contact.detailAddress !== null && contact.detailAddress.slice(-1) === '?'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    style="color:#00cae3;margin-left:5px"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Địa chỉ chi tiết đang được xác thực</span>
              </v-tooltip>
            </td>
            <template
              v-for="(attribute, index) in rowAttributes.filter(data => data.object === 'parent')"
            >
              <td
                :rowspan="contact.rowspan"
                v-show="statusRowAttribute(attribute.name)"
                :key="'coloumn_parent_'+ index"
              >{{ _.get(contact, `parentCustomer.${attribute.name}`, '') }}</td>
            </template>
            <td
              v-if="!(filterForm.typeId == moduleTypes.TU_HOC &&
              (filterForm.schoolLevelId == moduleSchoolLevel.TH ||
               filterForm.schoolLevelId == moduleSchoolLevel.THCS) &&
               !USER_NOT_SHOW_CONTACT_SOURCE.includes(userId))"
              v-show="statusRowAttribute('contactSources')"
              :rowspan="contact.rowspan"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'contactSourcesList', indexChild: 0, id: contact.childCustomer[0].editId, type: 'select', oldValue: contact.contactSourcesList})"
            >
              <span v-if="!contact.childCustomer[0].editAttrs.contactSourcesList">{{ _.get(contact, 'contactSources', '') }}</span>
              <v-autocomplete
                v-if="contact.childCustomer[0].editAttrs.contactSourcesList"
                v-model="contact.contactSourcesList"
                :items="contactSources"
                item-text="name"
                item-value="id"
                label="Nguồn khách hàng"
                multiple
                @keyup.enter.native="onChangeAttribute(contact, 'contactSourcesList', index, 0, contact.id, $event)"
              />
            </td>
            <template
              v-for="(attribute, index) in rowAttributes.filter(data => data.object === 'contact')"
            >
              <td
                :rowspan="contact.rowspan"
                v-show="statusRowAttribute(attribute.name)"
                :key="'coloumn_contact_'+ index"
              >{{_.get(contact, attribute.name, '')}}</td>
            </template>
            <template
              v-for="(attribute, index) in rowAttributes.filter(data => data.object === 'main_customer')"
            >
              <td
                :rowspan="contact.rowspan"
                v-show="statusRowAttribute(attribute.name)"
                :key="'coloumn_main_customer_'+ index"
              >{{_.get(contact, attribute.name, '')}}</td>
            </template>
            <td
              style="min-width: 10rem;"
              v-show="statusRowAttribute('user')"
              :rowspan="contact.rowspan"
            >
            {{ _.get(contact, 'user.fullName', '') }}
            </td>
            <!-- <td
              style="min-width: 10rem;"
              v-show="statusRowAttribute('user')"
              :rowspan="contact.rowspan"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'userFullName', indexChild: 0, id: contact.childCustomer[0].editId, type: 'select', oldValue: contact.user.id})"
            >
              <span v-if="!contact.childCustomer[0].editAttrs.userFullName">{{ _.get(contact, 'user.fullName', '') }}</span>
              <v-autocomplete
                v-if="contact.childCustomer[0].editAttrs.userFullName"
                v-model="contact.user.id"
                :items="users"
                item-text="fullName"
                item-value="id"
                label="Người phụ trách"
                @change="onChangeAttribute(contact, 'userFullName', index, 0, contact.id)"
              />
            </td> -->
            <td
              v-show="statusRowAttribute('groups')"
              :rowspan="contact.rowspan"
            >{{ _.get(contact, 'groups', '') }}</td>
            <td
              v-show="statusRowAttribute('cumulativePoint')"
              :rowspan="contact.rowspan"
            >{{ String(_.get(contact, 'cumulativePoint', '')) }}</td>
            <td
              v-show="statusRowAttribute('status')"
              :rowspan="contact.rowspan"
            >{{ _.get(contact, 'contactStatus.type', '') }} - {{ _.get(contact, 'contactStatus.name', '') }}</td>
            <td
              v-show="statusRowAttribute('appointment')"
              :rowspan="contact.rowspan"
              style="text-align: center"
              v-if="contact.appointments"
            >
              <v-row>
                <v-col cols="10" style="padding-right: 4px; text-align: center" @click="editAppointment(contact)">
                  <div class="appointment-time-wrapper"><b>{{checkAppointmentTime(contact.appointments.date)}}</b></div>&nbsp;
                </v-col>
                <v-col cols="2" style="padding-left: 4px; text-align: left">
                  <v-menu offset-y v-if="statusCallCenter && contact.contactType == 'main'">
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                            min-width="22px !important"
                            height="22"
                            class="btn-notification"
                            dark
                            small
                            style="margin-top: 3px"
                            v-bind="attrs"
                            v-on="{...tooltip, ...menu}"
                          >
                            <v-icon class="icon-flipped" size="16">mdi-phone</v-icon>
                          </v-btn>
                        </template>
                        <span>Thực hiện lịch hẹn</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="showAppoimentAction(contact, _.get(contact, 'mobile', ''))"
                        class="main-mobile"
                      >
                        <v-list-item-title>{{_.get(contact, 'mobile', '')}}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-for="(phone, index) in contact.phoneRelated"
                        :key="index"
                        @click="showAppoimentAction(contact, phone)"
                        class="sub-mobile"
                      >
                        <v-list-item-title>{{phone}}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-tooltip v-else-if="statusCallCenter" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        min-width="22px !important"
                        height="22"
                        class="btn-notification"
                        dark
                        small
                        style="margin-top: 3px"
                        v-on="on"
                        @click="showAppoimentAction(contact, _.get(contact, 'mobile', ''))"
                      >
                        <v-icon class="icon-flipped" size="16">mdi-phone</v-icon>
                      </v-btn>
                    </template>
                    <span>Thực hiện lịch hẹn</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </td>
            <td
              v-show="statusRowAttribute('appointment')"
              :rowspan="contact.rowspan"
              style="text-align: center"
              v-else
            >Không có</td>
            <!-- <td
              v-show="statusRowAttribute('description')"
              :rowspan="contact.rowspan"
              @dblclick="enableEditAttribute(contact, {contact: contact.childCustomer[0], index: index, e: $event, attr: 'description', indexChild: 0, id: contact.childCustomer[0].editId, type: 'input', oldValue: contact.description})"
            >
              {{ _.get(contact, 'description', '') }}
              <span v-if="!contact.childCustomer[0].editAttrs.description">{{ _.get(contact, 'description', '') }}</span>
              <textarea v-if="contact.childCustomer[0].editAttrs.description"
              v-bind:id="'description_' + contact.childCustomer[0].editId"
              style="width: 100%; height: 80%; padding-left: 5px; margin-top: 8px"
              :value="contact.description"
              @change="onChangeAttribute(contact, 'description', index, 0, contact.id, $event)"/>
            </td> -->
            <td
              v-show="statusRowAttribute('historyOrder')"
              :rowspan="contact.rowspan"
            >{{ _.get(contact, 'historyOrder', 'Không') }}</td>

            <td
                v-show="statusRowAttribute('schoolLevelsName')"
                :rowspan="contact.rowspan"
            >
              <span>
                {{ _.get(contact, 'schoolLevels.name', '') }}
              </span>
            </td>

            <td
                v-show="statusRowAttribute('typeName')"
                :rowspan="contact.rowspan"
            >
              <span>
                {{ _.get(contact, 'types.name', '') }}
              </span>
            </td>

            <td v-show="statusRowAttribute('schoolName')">
              <span>{{ _.get(contact.childCustomer[0], 'schoolName', '') }}</span>
            </td>

            <td v-show="statusRowAttribute('activeCode')">
              <div v-if="contact.childCustomer[0].activeCode && contact.childCustomer[0].activeCode.length">
                <span v-if="contact.childCustomer[0].activeCode.length === 1">
                  {{contact.childCustomer[0].activeCode[0]}}
                </span>
                <v-tooltip v-if="contact.childCustomer[0].activeCode.length > 1" bottom>
                  <template
                    v-slot:activator="{ on }"
                  >
                    <span v-on="on">{{contact.childCustomer[0].activeCode[0]}}, ...</span>
                  </template>
                  <div
                    v-for="(active, keyActive) in contact.childCustomer[0].activeCode"
                    :key="keyActive">
                    {{active}}<br>
                  </div>
                </v-tooltip>
              </div>
            </td>

            <td class="action-cell" :rowspan="contact.rowspan">
              <div class="action">
                <!-- <v-tooltip bottom v-if="checkConditionT4NT5(_.get(contact, 'contactStatus.type', ''))">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      size="16"
                      class="mr-1"
                      width="20"
                      height="20"
                      @click="clickNewAppointment(contact)"
                      icon
                      small
                      color="warning"
                      v-on="on"
                    >
                      <v-icon size="16">mdi-timer</v-icon>
                    </v-btn>
                  </template>
                  <span>Tạo lịch hẹn</span>
                </v-tooltip> -->
                <v-dialog
                  transition="dialog-bottom-transition"
                  max-width="600"
                  class=""
                  persistent
                >
                  <template v-if="(contact.schoolLevelId == 4 || contact.typeId == 2 )" v-slot:activator="{ on: dialog, attrs }">
                    <v-tooltip bottom>
                      <template #activator="{ on: tooltip }">
                        <v-btn
                          icon
                          color="primary"
                          class="mx-2"
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...dialog }"
                          width="22"
                          height="22"
                          @click="helpBox(contact)"
                          style="display: none"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.3333 13.3333H2.66665V4.66667C2.66665 4.3 2.36665 4 1.99998 4C1.63331 4 1.33331 4.3 1.33331 4.66667V13.3333C1.33331 14.0667 1.93331 14.6667 2.66665 14.6667H11.3333C11.7 14.6667 12 14.3667 12 14C12 13.6333 11.7 13.3333 11.3333 13.3333Z"
                              fill="#6600CC"
                            />
                            <path
                              d="M13.3333 1.33337H5.33333C4.6 1.33337 4 1.93337 4 2.66671V10.6667C4 11.4 4.6 12 5.33333 12H13.3333C14.0667 12 14.6667 11.4 14.6667 10.6667V2.66671C14.6667 1.93337 14.0667 1.33337 13.3333 1.33337ZM9.34 10C8.94667 10 8.64 9.68671 8.64 9.30004C8.64 8.90671 8.95333 8.60671 9.34 8.60671C9.73333 8.60671 10.0333 8.90671 10.0333 9.30004C10.0267 9.68671 9.73333 10 9.34 10ZM11.0067 5.88671C10.5867 6.50671 10.1867 6.69337 9.96667 7.09337C9.91333 7.18671 9.88 7.26671 9.86 7.42004C9.82667 7.68004 9.62 7.87337 9.36 7.87337H9.34C9.04667 7.87337 8.81333 7.62004 8.84 7.32671C8.86 7.14004 8.9 6.94671 9.00667 6.76671C9.28 6.28004 9.79333 5.99337 10.0933 5.56671C10.4133 5.11337 10.2333 4.27337 9.33333 4.27337C8.92667 4.27337 8.66 4.48671 8.49333 4.74004C8.36667 4.93337 8.11333 5.00004 7.9 4.90671C7.62 4.78671 7.5 4.44004 7.67333 4.19337C8.01333 3.70004 8.58 3.33337 9.32667 3.33337C10.1467 3.33337 10.7133 3.70671 11 4.17337C11.2467 4.58004 11.3867 5.32671 11.0067 5.88671Z"
                              fill="#6600CC"
                            />
                          </svg>
                        </v-btn>
                      </template>
                      <span>Quản lý bài test</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:default="dialog">
                    <v-card class="">
                      <v-toolbar
                        color="white"
                        dark
                        elevation="0"
                        class="
                          black--text
                          text-center
                          font-weight-bold
                          d-flex
                          justify-center
                          display-1
                        "
                        style="font-size: 18px !important"
                        >Quản lý hoạt động bài test năng lực Tutoring</v-toolbar
                      >
                      <v-divider></v-divider>
                      <div class="d-flex justify-center">
                        <v-card
                          width="180"
                          height="160"
                          class="
                            rouned-2
                            d-flex
                            justify-center
                            align-center
                            flex-column
                            mt-4
                            mr-7
                          "
                          style="border: 1px solid #e0e0e0"
                        >
                          <div>
                            <svg
                              width="40"
                              height="40"
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0)">
                                <path
                                  d="M34.5536 3.60754H5.44629C2.878 3.60754 0.795898 5.68965 0.795898 8.25794V35.3496C0.795898 37.9179 2.878 40 5.44629 40H34.5536C37.1219 40 39.204 37.9179 39.204 35.3496V8.25794C39.204 5.68952 37.1219 3.60754 34.5536 3.60754Z"
                                  fill="#EBF0F3"
                                />
                                <path
                                  d="M39.204 12.3451V6.71045C39.204 4.14216 37.1219 2.06006 34.5536 2.06006H5.44629C2.878 2.06006 0.795898 4.14216 0.795898 6.71045V12.3451H39.204Z"
                                  fill="#CE412D"
                                />
                                <path
                                  d="M39.204 13.3964V8.25794C39.204 5.68965 37.1219 3.60754 34.5536 3.60754H5.44629C2.878 3.60754 0.795898 5.68965 0.795898 8.25794V13.3964H39.204Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M8.41323 6.1051C7.51683 6.1051 6.79016 6.83177 6.79016 7.72817C6.79016 8.62457 7.51683 9.35111 8.41323 9.35111C9.30963 9.35111 10.0362 8.62444 10.0362 7.72817C10.0363 6.83177 9.30963 6.1051 8.41323 6.1051Z"
                                  fill="#D15241"
                                />
                                <path
                                  d="M8.41323 0C7.93374 0 7.54492 0.388814 7.54492 0.868312V7.63358C7.54492 8.11321 7.93374 8.50189 8.41323 8.50189C8.89273 8.50189 9.28155 8.11321 9.28155 7.63358V0.868312C9.28155 0.388814 8.89287 0 8.41323 0V0Z"
                                  fill="#4D5C7D"
                                />
                                <path
                                  d="M16.1377 6.1051C15.2413 6.1051 14.5146 6.83177 14.5146 7.72817C14.5146 8.62457 15.2413 9.35111 16.1377 9.35111C17.0341 9.35111 17.7607 8.62444 17.7607 7.72817C17.7608 6.83177 17.0341 6.1051 16.1377 6.1051Z"
                                  fill="#D15241"
                                />
                                <path
                                  d="M16.1376 0C15.6581 0 15.2693 0.388814 15.2693 0.868312V7.63358C15.2693 8.11321 15.6581 8.50189 16.1376 8.50189C16.6171 8.50189 17.0059 8.11321 17.0059 7.63358V0.868312C17.0059 0.388814 16.6171 0 16.1376 0V0Z"
                                  fill="#4D5C7D"
                                />
                                <path
                                  d="M23.8622 6.1051C22.9658 6.1051 22.2391 6.83177 22.2391 7.72817C22.2391 8.62457 22.9658 9.35111 23.8622 9.35111C24.7586 9.35111 25.4851 8.62444 25.4851 7.72817C25.4851 6.83177 24.7586 6.1051 23.8622 6.1051Z"
                                  fill="#D15241"
                                />
                                <path
                                  d="M23.8622 0C23.3827 0 22.9939 0.388814 22.9939 0.868312V7.63358C22.9939 8.11321 23.3827 8.50189 23.8622 8.50189C24.3417 8.50189 24.7305 8.11321 24.7305 7.63358V0.868312C24.7305 0.388814 24.3417 0 23.8622 0V0Z"
                                  fill="#4D5C7D"
                                />
                                <path
                                  d="M31.5867 6.1051C30.6903 6.1051 29.9636 6.83177 29.9636 7.72817C29.9636 8.62457 30.6903 9.35111 31.5867 9.35111C32.4831 9.35111 33.2096 8.62444 33.2096 7.72817C33.2096 6.83177 32.483 6.1051 31.5867 6.1051Z"
                                  fill="#D15241"
                                />
                                <path
                                  d="M31.5866 0C31.1071 0 30.7183 0.388814 30.7183 0.868312V7.63358C30.7183 8.11321 31.1071 8.50189 31.5866 8.50189C32.0661 8.50189 32.4549 8.11321 32.4549 7.63358V0.868312C32.4549 0.388814 32.0662 0 31.5866 0V0Z"
                                  fill="#4D5C7D"
                                />
                                <path
                                  d="M14.9677 19.8215H18.4779V23.3318H14.9677V19.8215Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M21.5221 19.8215H25.0324V23.3318H21.5221V19.8215Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M28.0764 19.8215H31.5867V23.3318H28.0764V19.8215Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M8.41321 25.3245H11.9235V28.8348H8.41321V25.3245Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M14.9677 25.3245H18.4779V28.8348H14.9677V25.3245Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M21.5221 25.3245H25.0324V28.8348H21.5221V25.3245Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M28.0764 25.3245H31.5867V28.8348H28.0764V25.3245Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M8.41321 30.8274H11.9235V34.3377H8.41321V30.8274Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M14.9677 30.8274H18.4779V34.3377H14.9677V30.8274Z"
                                  fill="#E56353"
                                />
                                <path
                                  d="M21.5221 30.8274H25.0324V34.3377H21.5221V30.8274Z"
                                  fill="#E56353"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0">
                                  <rect width="40" height="40" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <v-card-actions>
                            <v-dialog
                              v-model="dialogModal"
                              persistent
                              max-width="800px"
                              :retain-focus="false"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="#FF6609"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  rounded
                                >
                                  Tạo lịch test
                                </v-btn>
                              </template>
                              <v-card>
                                <v-card-title>
                                  <span
                                    class="text-h5"
                                    style="
                                      font-size: 18px !important;
                                      color: #333333;
                                      font-weight: 500;
                                    "
                                    >Tạo link bài test tutoring</span
                                  >
                                </v-card-title>
                                <v-card-text>
                                  <v-container>
                                    <validation-observer
                                      ref="validator"
                                      v-slot="{ handleSubmit }"
                                    >
                                      <v-row>
                                        <v-col cols="12" md="6" class="pa-0">
                                          <label
                                            for=""
                                            style="
                                              color: #000000;
                                              font-size: 16px;
                                              font-weight: normal;
                                            "
                                            >Chọn con để tạo bài kiểm tra
                                            <span style="color: red">(*)</span>
                                          </label>
                                          <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                            name="Chọn con"
                                          >
                                            <div>
                                              <v-select
                                                class="pt-0 mt-0"
                                                :error-messages="errors"
                                                :items="fullNameChild"
                                                item-text="fullName"
                                                item-value="id"
                                                v-model="selectChild"
                                                dense
                                                placeholder="--Chọn con--"
                                                outlined
                                                no-data-text="Không có con"
                                                @change="
                                                  checkTestLink(selectChild)
                                                "
                                              ></v-select>
                                            </div>
                                          </validation-provider>
                                        </v-col>
                                        <v-col cols="12" md="6" class="pa-0">
                                          <v-list
                                            dense
                                            height="92"
                                            class="pa-0"
                                          >
                                            <v-list-item
                                              dense
                                              class="body-2"
                                              style="
                                                min-height: 28px;
                                                font-size: 16px !important;
                                              "
                                            >
                                              Phụ huynh :
                                              <strong style="color: #4e4b66">{{
                                                contact.fullName
                                              }}</strong>
                                            </v-list-item>
                                            <v-list-item
                                              v-for="(
                                                contact, index
                                              ) in contactsFilter"
                                              :key="index"
                                              dense
                                              class="body-2"
                                              style="
                                                min-height: 28px;
                                                font-size: 16px !important;
                                              "
                                            >
                                              Số điện thoại :
                                              <strong style="color: #4e4b66">
                                                {{ contact.mobile }} </strong
                                              >
                                            </v-list-item>
                                          </v-list>
                                        </v-col>
                                        <v-col md="6" class="pa-0">
                                          <label
                                            for=""
                                            style="
                                              color: #000000;
                                              font-size: 16px;
                                              font-weight: normal;
                                            "
                                            >Chọn thời gian lịch test
                                            <span style="color: red">(*)</span>
                                          </label>
                                          <div
                                            style="position: relative"
                                            id="pick-time-date"
                                          >
                                            <DatetimePicker
                                              dateIcon
                                              timeIcon
                                              v-if="dialogModal"
                                              @input="checkTime"
                                              v-click-outside="clickOutside"
                                              ref="myDateTime"
                                              v-model="nullDatetime"
                                              placeholder="--Chọn lịch test--"
                                              label="--Chọn lịch test--"
                                            >
                                              <template slot="dateIcon">
                                                <v-icon
                                                  >mdi-calendar-range</v-icon
                                                >
                                              </template>
                                              <template slot="timeIcon">
                                                <v-icon
                                                  >mdi-clock-outline</v-icon
                                                >
                                              </template>
                                            </DatetimePicker>

                                            <svg
                                              style="
                                                position: absolute;
                                                right: 10px;
                                                top: 10px;
                                              "
                                              width="21"
                                              height="21"
                                              viewBox="0 0 21 21"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M2 8H16V10H18V4C18 2.9 17.1 2 16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H9V18H2V8ZM2 4H16V6H2V4ZM19.84 14.28L19.13 14.99L17.01 12.87L17.72 12.16C18.11 11.77 18.74 11.77 19.13 12.16L19.84 12.87C20.23 13.26 20.23 13.89 19.84 14.28ZM16.3 13.58L18.42 15.7L13.12 21H11V18.88L16.3 13.58Z"
                                                fill="#4E4B66"
                                              />
                                            </svg>
                                          </div>
                                        </v-col>
                                        <v-col class="pa-0" md="6">
                                          <v-list
                                            dense
                                            height="92"
                                            class="pa-0"
                                          >
                                            <v-list-item
                                              dense
                                              class="body-2"
                                              style="
                                                min-height: 28px;
                                                margin-top: 20px;
                                                font-size: 16px !important;
                                              "
                                            >
                                              Ngày :
                                              <strong style="color: #4e4b66">{{
                                                pickTimeFilter
                                              }}</strong>
                                            </v-list-item>
                                            <v-list-item
                                              style="
                                                font-size: 16px !important;
                                                font-weight: 400;
                                              "
                                              >Giờ hẹn:
                                              <strong style="color: #4e4b66">{{
                                                pickHour
                                              }}</strong></v-list-item
                                            >
                                          </v-list>
                                        </v-col>
                                        <v-col cols="12" md="3" style="">
                                          <div class="d-flex flex-column">
                                            <div style="">
                                              <v-btn
                                                width="100"
                                                text
                                                @click="checkObjectMath()"
                                                :style="`${
                                                  objectSelect == 0
                                                    ? 'background:#F8FBFF;color:#2F80ED;border-bottom: 1px solid #2F80ED;'
                                                    : 'color: #A0A3BD;border-bottom: 1px solid #E0E0E0;'
                                                }`"
                                              >
                                                Môn toán</v-btn
                                              >
                                            </div>
                                            <div>
                                              <v-btn
                                                @click="
                                                  checkLinkEnglish({
                                                    selectChild: selectChild,
                                                    contact: contact,
                                                  })
                                                "
                                                width="100"
                                                text
                                                color=""
                                                :style="`${
                                                  objectSelect == 1
                                                    ? 'background:#F8FBFF;color:#2F80ED;border-bottom: 1px solid #2F80ED;'
                                                    : 'color: #A0A3BD;border-bottom: 1px solid #E0E0E0;'
                                                }`"
                                                >Môn tiếng Anh</v-btn
                                              >
                                            </div>
                                          </div>
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="9"
                                          style="background: #f8fbff"
                                        >
                                          <div>
                                            <div
                                              v-if="objectSelect == 0"
                                              class="
                                                d-flex

                                                w-100
                                              "
                                              style=""
                                            >
                                            <div v-for="math in getMath" :key="math.grade_id">
                                              <v-radio-group v-model="ex5" row >
                                                <v-radio
                                                  color="blue"
                                                  on-icon="mdi-circle-slice-8"
                                                  off-icon="mdi-checkbox-blank-circle-outline"
                                                  :label="math.text"
                                                  :value="math.text"
                                                  :disabled="checkDisabled"
                                                  @change="checkMath(math)"
                                                ></v-radio>
                                              </v-radio-group>
                                            </div>
                                            </div>
                                            <div v-if="objectSelect == 1">
                                              <div
                                                v-for="listObject in listObjects"
                                                :key="listObject.id"
                                                class="
                                                  d-flex

                                                  w-100
                                                "
                                                style=""
                                              >
                                                <v-radio-group
                                                  v-model="englishRadio"
                                                  row
                                                >
                                                  <v-radio
                                                    on-icon="mdi-circle-slice-8"
                                                    off-icon="mdi-checkbox-blank-circle-outline"
                                                    color="blue"
                                                    :disabled="
                                                      checkDisabledEnglish
                                                    "
                                                    v-for="englishObject in listObject.level"
                                                    :key="englishObject.id"
                                                    @change="
                                                      checkEnglish(
                                                        englishObject
                                                      )
                                                    "
                                                    :label="englishObject.text"
                                                    :value="englishObject.text"
                                                  ></v-radio>
                                                </v-radio-group>
                                              </div>
                                            </div>
                                            <div>
                                              <div
                                                class="d-flex align-center"
                                                v-if="isCoppy"
                                              >
                                                <a
                                                  v-if="
                                                    objectSelect == 0 &&
                                                    myMathlink
                                                  "
                                                  :href="myMathlink"
                                                  target="_blank"
                                                  rounded
                                                  class="
                                                    display-1
                                                    width-100
                                                    text-truncate
                                                  "
                                                  style="
                                                    border: 1px solid #2f80ed;
                                                    background: #f8fbff;
                                                    height: 48px;
                                                    width: 90%;
                                                    color: #2f80ed;
                                                    border-radius: 8px;
                                                    padding-left: 8px;
                                                    padding-top: 10px;
                                                  "
                                                  >{{ renderTextLink }}
                                                  {{ myMathlink }}
                                                  {{ myInput }}</a
                                                >
                                                <a
                                                  v-if="
                                                    objectSelect == 1 &&
                                                    myEnglishlink
                                                  "
                                                  :href="`${
                                                    renderTextLink
                                                      ? renderTextLink
                                                      : myEnglishlink
                                                  }`"
                                                  target="_blank"
                                                  rounded
                                                  class="
                                                    display-1
                                                    width-100
                                                    text-truncate
                                                  "
                                                  style="
                                                    border: 1px solid #2f80ed;
                                                    background: #f8fbff;
                                                    height: 48px;
                                                    width: 90%;
                                                    color: #2f80ed;
                                                    border-radius: 8px;
                                                    padding-left: 8px;
                                                    padding-top: 10px;
                                                  "
                                                  >{{ renderTextLink }}
                                                  {{ myEnglishlink }}</a
                                                >
                                                <v-btn
                                                  icon
                                                  class="ml-4"
                                                  color="#2F80ED"
                                                  @click="coppyText"
                                                  style="
                                                    background-color: white;
                                                  "
                                                >
                                                  <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M15 1H4C2.9 1 2 1.9 2 3V16C2 16.55 2.45 17 3 17C3.55 17 4 16.55 4 16V4C4 3.45 4.45 3 5 3H15C15.55 3 16 2.55 16 2C16 1.45 15.55 1 15 1ZM15.59 5.59L20.42 10.42C20.79 10.79 21 11.3 21 11.83V21C21 22.1 20.1 23 19 23H7.99C6.89 23 6 22.1 6 21L6.01 7C6.01 5.9 6.9 5 8 5H14.17C14.7 5 15.21 5.21 15.59 5.59ZM15 12H19.5L14 6.5V11C14 11.55 14.45 12 15 12Z"
                                                      fill="#2F80ED"
                                                    />
                                                  </svg>
                                                </v-btn>
                                                <v-snackbar
                                                  color="#3C88EE"
                                                  v-model="snackbar"
                                                >
                                                  Coppy link thành công!

                                                  <template
                                                    v-slot:action="{ attrs }"
                                                  >
                                                    <v-btn
                                                      color="pink"
                                                      text
                                                      v-bind="attrs"
                                                      @click="snackbar = false"
                                                    >
                                                      Đóng
                                                    </v-btn>
                                                  </template>
                                                </v-snackbar>
                                              </div>
                                              <v-btn
                                                v-if="isCoppy == false && objectSelect == 0"
                                                @click.prevent="
                                                  handleSubmit();
                                                  createTutorLink();
                                                "
                                                :disabled="
                                                  !selectChild ||
                                                  !nullDatetime ||
                                                  errorTime ||
                                                  !objectMath
                                                "
                                                color="#2F80ED"
                                              >
                                                <svg
                                                  style="margin-right: 12px"
                                                  width="20"
                                                  height="20"
                                                  viewBox="0 0 20 20"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14 11H11V14C11 14.55 10.55 15 10 15C9.45 15 9 14.55 9 14V11H6C5.45 11 5 10.55 5 10C5 9.45 5.45 9 6 9H9V6C9 5.45 9.45 5 10 5C10.55 5 11 5.45 11 6V9H14C14.55 9 15 9.45 15 10C15 10.55 14.55 11 14 11Z"
                                                    fill="white"
                                                  />
                                                </svg>

                                                Tạo Link bài test</v-btn
                                              >
                                              <v-btn
                                                v-if="isCoppy == false && objectSelect == 1"
                                                @click.prevent="
                                                  handleSubmit();
                                                  createTutorLink();
                                                "
                                                :disabled="
                                                  !selectChild ||
                                                  !nullDatetime ||
                                                  errorTime ||
                                                  !objectEnglish
                                                "
                                                color="#2F80ED"
                                              >
                                                <svg
                                                  style="margin-right: 12px"
                                                  width="20"
                                                  height="20"
                                                  viewBox="0 0 20 20"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14 11H11V14C11 14.55 10.55 15 10 15C9.45 15 9 14.55 9 14V11H6C5.45 11 5 10.55 5 10C5 9.45 5.45 9 6 9H9V6C9 5.45 9.45 5 10 5C10.55 5 11 5.45 11 6V9H14C14.55 9 15 9.45 15 10C15 10.55 14.55 11 14 11Z"
                                                    fill="white"
                                                  />
                                                </svg>

                                                Tạo Link bài test</v-btn
                                              >
                                            </div>
                                          </div>
                                        </v-col>
                                      </v-row>
                                    </validation-observer>
                                  </v-container>
                                </v-card-text>
                                <v-card-actions class="d-flex">
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    color="#6E7191"
                                    text
                                    outlined
                                    rounded
                                    @click="closeTutorTest()"
                                  >
                                    Đóng
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                              <v-snackbar
                                v-model="snackbarTestLink"
                                :timeout="2000"
                              >
                                Link bài test đã được tạo
                              </v-snackbar>
                            </v-dialog>
                          </v-card-actions>
                        </v-card>
                        <v-card
                          v-if="contactTutors.length > 0"
                          width="180"
                          height="160"
                          class="
                            rouned-2
                            d-flex
                            justify-center
                            align-center
                            flex-column
                            mt-4
                            mr-7
                          "
                          style="border: 1px solid #e0e0e0"
                        >
                          <div>
                            <svg
                              width="36"
                              height="40"
                              viewBox="0 0 36 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.1448 39.2531H33.6017C33.6915 39.2531 33.774 39.2032 33.8156 39.1236L35.946 35.0527C35.9827 34.9826 35.9827 34.8989 35.946 34.8288L33.8156 30.7556C33.774 30.676 33.6915 30.6261 33.6016 30.6261H10.1448L7.72864 34.5052L10.1448 39.2531Z"
                                fill="#FFD772"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.1448 39.2531V30.626V30.2954C10.1448 30.0665 9.95751 29.8815 9.7286 29.8815H0.440396C0.211489 29.8815 0.0264893 30.0665 0.0264893 30.2954V39.5837C0.0264893 39.8104 0.209146 39.9976 0.435786 39.9999H0.440396H9.72852H9.73313C9.95969 39.9976 10.1447 39.8103 10.1447 39.5837V39.2531H10.1448Z"
                                fill="#F9F7F8"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M0.440396 25.0582H9.72852C9.95743 25.0582 10.1447 24.8709 10.1447 24.6442V24.3136V15.6842V15.3558C10.1447 15.1269 9.95743 14.9396 9.72852 14.9396H0.440396C0.211489 14.9396 0.0264893 15.1269 0.0264893 15.3558V24.6442C0.0264893 24.8708 0.211489 25.0582 0.440396 25.0582Z"
                                fill="#F9F7F8"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.1448 15.6841L7.57239 19.8177L10.1448 24.3136H33.6016C33.6915 24.3136 33.7739 24.2637 33.8156 24.1841L35.9461 20.1108C35.9827 20.0407 35.9827 19.9571 35.9461 19.887L33.8156 15.8137C33.774 15.7341 33.6915 15.6841 33.6016 15.6841H10.1448Z"
                                fill="#75CEF8"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.1448 9.37166H33.6017C33.6915 9.37166 33.774 9.32174 33.8156 9.24213L35.946 5.17119C35.9827 5.10111 35.9827 5.01744 35.946 4.94736L33.8156 0.87416C33.774 0.794551 33.6915 0.744629 33.6016 0.744629H10.1448L7.88489 4.60939L10.1448 9.37166Z"
                                fill="#EB5468"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.1448 9.37164V0.744531V0.413906C10.1448 0.185 9.95751 0 9.7286 0H0.440396C0.211489 0 0.0264893 0.185 0.0264893 0.413906V9.70227C0.0264893 9.93117 0.211489 10.1184 0.440396 10.1184H9.72852C9.95743 10.1184 10.1447 9.93117 10.1447 9.70227V9.37164H10.1448Z"
                                fill="#F9F7F8"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.20816 0.744531V9.37164V9.70227C7.20816 9.93117 7.0209 10.1184 6.79199 10.1184H9.72848C9.95738 10.1184 10.1446 9.93117 10.1446 9.70227V9.37164V0.744531V0.413906C10.1446 0.185 9.95738 0 9.72848 0H6.79199C7.0209 0 7.20816 0.185 7.20816 0.413906V0.744531Z"
                                fill="#DDDAEC"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.72848 14.9396H6.79199C7.0209 14.9396 7.20816 15.1269 7.20816 15.3558V15.6842V24.3135V24.6442C7.20816 24.8708 7.0209 25.0581 6.79199 25.0581H9.72848C9.95738 25.0581 10.1446 24.8708 10.1446 24.6442V24.3135V15.6842V15.3558C10.1446 15.1269 9.95738 14.9396 9.72848 14.9396Z"
                                fill="#DDDAEC"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.72848 29.8815H6.79199C7.0209 29.8815 7.20816 30.0665 7.20816 30.2954V30.626V39.2531V39.5837C7.20816 39.8104 7.02316 39.9976 6.7966 39.9999H9.72848H9.73309C9.95965 39.9976 10.1446 39.8103 10.1446 39.5837V39.2531V30.626V30.2954C10.1446 30.0665 9.95738 29.8815 9.72848 29.8815Z"
                                fill="#DDDAEC"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M30.076 0.744507C30.6125 2.22435 30.9131 3.87302 30.9131 5.61185C30.9131 6.92982 30.742 8.19466 30.4252 9.37162H33.6017C33.6915 9.37162 33.7739 9.32169 33.8156 9.24209L35.946 5.17115C35.9827 5.10107 35.9827 5.0174 35.946 4.94732L33.8156 0.874116C33.7739 0.794507 33.6915 0.744585 33.6016 0.744585H30.076V0.744507Z"
                                fill="#E5384F"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M30.076 15.6842C30.6125 17.164 30.9131 18.8127 30.9131 20.5538C30.9131 21.8695 30.742 23.1342 30.4252 24.3135H33.6016C33.6914 24.3135 33.7739 24.2636 33.8156 24.184L35.9461 20.1107C35.9827 20.0406 35.9827 19.9571 35.9461 19.8869L33.8156 15.8136C33.7739 15.734 33.6915 15.6841 33.6016 15.6841H30.076V15.6842Z"
                                fill="#60B7FF"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M30.076 30.626C30.6125 32.1059 30.9131 33.7546 30.9131 35.4934C30.9131 36.8091 30.742 38.0762 30.4252 39.2531H33.6017C33.6915 39.2531 33.7739 39.2032 33.8156 39.1236L35.946 35.0527C35.9827 34.9826 35.9827 34.8989 35.946 34.8288L33.8156 30.7556C33.7739 30.676 33.6915 30.6261 33.6016 30.6261H30.076V30.626Z"
                                fill="#FBBA58"
                              />
                              <path
                                d="M5.55957 7.88264C5.22621 7.88264 4.95597 7.61241 4.95597 7.27905V3.44077H4.60933C4.27597 3.44077 4.00574 3.17053 4.00574 2.83718C4.00574 2.50382 4.27597 2.23358 4.60933 2.23358H5.55964C5.893 2.23358 6.16324 2.50382 6.16324 2.83718V7.27905C6.16324 7.61241 5.893 7.88264 5.55957 7.88264Z"
                                fill="#2B4D66"
                              />
                              <path
                                d="M4.86634 22.8686C3.9983 22.8686 3.93001 22.8458 3.84947 22.819C3.64994 22.751 3.50361 22.601 3.44447 22.4063C3.34501 22.0788 3.49884 21.8777 3.77806 21.5124C4.00306 21.2181 4.42197 20.6702 5.12751 19.662C5.36447 19.3241 5.46173 19.0837 5.50126 18.9347L5.51251 18.841C5.49712 18.5615 5.26384 18.3387 4.97939 18.3387C4.72509 18.3387 4.50564 18.5184 4.45736 18.7661C4.39369 19.0934 4.07697 19.3071 3.74947 19.2432C3.42228 19.1795 3.20861 18.8626 3.27236 18.5353C3.4308 17.7219 4.14861 17.1314 4.97939 17.1314C5.93954 17.1314 6.72064 17.9115 6.72064 18.8704C6.72064 18.8945 6.71915 18.9185 6.71634 18.9424L6.69548 19.1159C6.69283 19.138 6.68892 19.16 6.68384 19.1818C6.59869 19.5445 6.40783 19.9391 6.11634 20.3547C5.72158 20.9188 5.41431 21.3423 5.17931 21.6595C5.52845 21.658 5.92259 21.6545 6.2965 21.6498C6.63033 21.6428 6.90353 21.9123 6.90783 22.2456C6.91212 22.579 6.64533 22.8527 6.31197 22.857C5.67329 22.8651 5.20783 22.8686 4.86634 22.8686Z"
                                fill="#2B4D66"
                              />
                              <path
                                d="M6.82456 33.8031C6.82456 32.843 6.04448 32.0619 5.08565 32.0619C4.25737 32.0619 3.53878 32.6523 3.3769 33.4656C3.31175 33.7926 3.52409 34.1104 3.85105 34.1755C4.17831 34.2409 4.49589 34.0283 4.56089 33.7013C4.61073 33.4509 4.83144 33.2692 5.08565 33.2692C5.37886 33.2692 5.6173 33.5087 5.6173 33.8031C5.6173 34.0976 5.37878 34.3372 5.08565 34.3372C4.7523 34.3372 4.48206 34.6074 4.48206 34.9408C4.48206 35.2742 4.7523 35.5444 5.08565 35.5444C5.37886 35.5444 5.6173 35.7829 5.6173 36.0761C5.6173 36.3706 5.37878 36.6102 5.08565 36.6102C4.82058 36.6102 4.59355 36.4137 4.55815 36.1578C4.55355 36.1223 4.55167 36.0986 4.55167 36.0761C4.55167 35.7427 4.28144 35.4725 3.94808 35.4725C3.61472 35.4725 3.34448 35.7427 3.34448 36.0761C3.34448 36.152 3.34956 36.2252 3.36167 36.3182C3.47972 37.1729 4.22081 37.8174 5.08565 37.8174C6.04448 37.8174 6.82456 37.0363 6.82456 36.0761C6.82456 35.6423 6.66448 35.2453 6.40081 34.9404C6.66448 34.635 6.82456 34.2375 6.82456 33.8031Z"
                                fill="#2B4D66"
                              />
                              <path
                                d="M17.1762 4.22696H13.4536C13.1202 4.22696 12.85 3.95673 12.85 3.62337C12.85 3.29001 13.1202 3.01978 13.4536 3.01978H17.1762C17.5096 3.01978 17.7798 3.29001 17.7798 3.62337C17.7798 3.95673 17.5096 4.22696 17.1762 4.22696Z"
                                fill="#2B4D66"
                              />
                              <path
                                d="M21.0214 7.19126H13.4536C13.1202 7.19126 12.85 6.92102 12.85 6.58766C12.85 6.2543 13.1202 5.98407 13.4536 5.98407H21.0214C21.3548 5.98407 21.625 6.2543 21.625 6.58766C21.625 6.92102 21.3548 7.19126 21.0214 7.19126Z"
                                fill="#2B4D66"
                              />
                              <path
                                d="M17.1762 19.0694H13.4536C13.1202 19.0694 12.85 18.7992 12.85 18.4658C12.85 18.1325 13.1202 17.8622 13.4536 17.8622H17.1762C17.5096 17.8622 17.7798 18.1325 17.7798 18.4658C17.7799 18.7991 17.5096 19.0694 17.1762 19.0694Z"
                                fill="#2B4D66"
                              />
                              <path
                                d="M21.0214 22.0361H13.4536C13.1202 22.0361 12.85 21.7659 12.85 21.4325C12.85 21.0992 13.1202 20.8289 13.4536 20.8289H21.0214C21.3548 20.8289 21.625 21.0992 21.625 21.4325C21.625 21.7659 21.3548 22.0361 21.0214 22.0361Z"
                                fill="#2B4D66"
                              />
                              <path
                                d="M17.1762 34.1039H13.4536C13.1202 34.1039 12.85 33.8336 12.85 33.5003C12.85 33.1669 13.1202 32.8967 13.4536 32.8967H17.1762C17.5096 32.8967 17.7798 33.1669 17.7798 33.5003C17.7799 33.8336 17.5096 34.1039 17.1762 34.1039Z"
                                fill="#2B4D66"
                              />
                              <path
                                d="M21.0214 37.0681H13.4536C13.1202 37.0681 12.85 36.7979 12.85 36.4646C12.85 36.1312 13.1202 35.861 13.4536 35.861H21.0214C21.3548 35.861 21.625 36.1312 21.625 36.4646C21.625 36.7979 21.3548 37.0681 21.0214 37.0681Z"
                                fill="#2B4D66"
                              />
                            </svg>
                          </div>
                          <v-card-actions>
                            <v-btn
                              text
                              color="#FF6609"
                              :to="{
                                path: `../tutor-test/${contact.mobile}`,
                              }"
                              target="_blank"
                              dark
                              outlined
                              rounded
                              @click="getResult"
                            >
                              Kết quả bài test
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </div>
                      <v-card-actions class="justify-end d-flex">
                        <v-btn
                          outlined
                          rounded
                          color="#6E7191"
                          class="text-capitalize"
                          @click="
                            closeTutorModal();
                            dialog.value = false;
                          "
                          >Đóng</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-menu offset-y v-if="statusCallCenter && contact.contactType == 'main'">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          size="16"
                          width="20"
                          height="20"
                          class="mr-1"
                          icon
                          small
                          color="success"
                          v-bind="attrs"
                          v-on="{...tooltip, ...menu}"
                        >
                          <v-icon size="16">mdi-phone</v-icon>
                        </v-btn>
                      </template>
                      <span>Gọi cho khách hàng</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="clickExecuteCall(contact, _.get(contact, 'mobile', ''))"
                      class="main-mobile"
                    >
                      <v-list-item-title>{{maskedPhoneNumber(_.get(contact, 'mobile', '')) }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-for="(phone, index) in contact.phoneRelated"
                      :key="index"
                      @click="clickExecuteCall(contact, phone)"
                      class="sub-mobile"
                    >
                      <v-list-item-title>{{maskedPhoneNumber(phone) }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu offset-y v-else-if="false">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            size="16"
                            width="20"
                            height="20"
                            class="mr-1"
                            icon
                            small
                            color="success"
                            v-bind="attrs"
                            v-on="{...tooltip, ...menu}"
                        >
                          <v-icon size="16">mdi-phone</v-icon>
                        </v-btn>
                      </template>
                      <span>Gọi cho khách hàng</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                        @click="clickExecuteCall(contact, '0332113666', 1)"
                        class="main-mobile"
                    >
                      <v-list-item-title>Epa</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        @click="clickExecuteCall(contact, '0332113666', 2)"
                        class="sub-mobile"
                    >
                      <v-list-item-title>CareSoft</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        @click="clickExecuteCall(contact, '0332113666', 4)"
                        class="sub-mobile"
                    >
                      <v-list-item-title>Ods</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-tooltip v-else-if="statusCallCenter" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      size="16"
                      width="20"
                      height="20"
                      @click="clickExecuteCall(contact, _.get(contact, 'mobile', ''))"
                      class="mr-1"
                      icon
                      small
                      color="success"
                      v-on="on"
                    >
                      <v-icon size="16">mdi-phone</v-icon>
                    </v-btn>
                  </template>
                  <span>Gọi cho khách hàng</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mr-1"
                      @click="clickContact(contact.id)"
                      icon
                      small
                      size="16"
                      width="20"
                      height="20"
                      color="primary"
                      v-on="on"
                    >
                      <v-icon size="16">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Cập nhật thông tin khách hàng</span>
                </v-tooltip>
                <template
                    v-if="checkAuthorization('merge-contact_read')"
                >
                  <v-tooltip
                      v-if="!contact.mainId && contact.contactType == null && contact.id"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="mr-1"
                          @click="preMergeContact(contact)"
                          icon
                          small
                          size="16"
                          width="20"
                          height="20"
                          color="primary"
                          v-on="on"
                      >
                        <v-icon size="16">mdi-call-merge</v-icon>
                      </v-btn>
                    </template>
                    <span>Gộp contact</span>
                  </v-tooltip>
                  <v-tooltip
                      v-else
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="mr-1"
                          @click="unmergeContact(contact)"
                          icon
                          small
                          size="16"
                          width="20"
                          height="20"
                          color="primary"
                          v-on="on"
                      >
                        <v-icon size="16">mdi-call-split</v-icon>
                      </v-btn>
                    </template>
                    <span>Bỏ gộp contact</span>
                  </v-tooltip>
                </template>
              </div>
            </td>
          </tr>
          <template v-for="(customer, indexChild) in contact.childCustomer">
            <tr class="child-table" v-if="indexChild > 0" :key="indexChild + `- ${contact.id}`">
              <td class="scroll-layout-left" :style="'min-width: 10rem; left:' + sticky_childFullName + 'px'" v-show="statusRowAttribute('childFullName')"
                @dblclick="enableEditAttribute(contact, {contact: customer, index: index, e: $event, attr: 'childFullName', indexChild: indexChild, id: customer.id, oldValue: customer.fullName})">
              <!-- <td class="scroll-layout-left" :style="'min-width: 10rem; left:' + sticky_childFullName + 'px'" v-show="statusRowAttribute('childFullName')"> -->
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-tooltip v-if="!_.get(customer,'isMainCustomer', false) && _.get(customer, 'fullName', '') && checkAuthorization('contact_update')" bottom>
                    <template
                      v-slot:activator="{ on }"
                    >
                      <v-btn
                        @click="checkCanDeleteCustomer(contact.id, _.get(customer,'id',''))"
                        icon
                        small
                        color="primary"
                        v-on="on"
                      >
                        <v-icon>mdi-account-remove</v-icon>
                      </v-btn>
                    </template>
                    <span>Xoá thông tin con</span>
                  </v-tooltip>
                  <!-- {{ _.get(customer, 'fullName', '') }} -->
                  <span v-if="!contact.childCustomer[indexChild].editAttrs.childFullName">{{ _.get(customer, 'fullName', '') }}</span>
                  <!-- <input v-if="contact.childCustomer[indexChild].editAttrs.childFullName"
                    v-bind:id="'childFullName_' + customer.id" type="text"
                    v-model="customer.fullName" style="width: calc(100% - 30px); height: 80%; padding-left: 5px"
                    @change="onChangeAttribute(customer, 'childFullName', index, indexChild, contact.id)"/> -->
                  <v-text-field
                    v-if="contact.childCustomer[indexChild].editAttrs.childFullName"
                    :id="'childFullName_' + customer.id"
                    :value="customer.fullName"
                    color="primary"
                    label="Tên con"
                    @change="onChangeAttribute(customer, 'childFullName', index, indexChild, contact.id, $event)"
                  />
                </div>
                <div class="tool-tips-bitu ml-2" v-if="contact.childCustomer[indexChild].isMainAccount" >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        v-on="on"
                        :size="size"
                        :color="color"
                        class="mx-2"
                        >
                        <img v-if="showBitu(contact.childCustomer[indexChild].userName)" src="../../../../public/img/bitu.svg" style="width: 25px;height: 20px;object-fit:fill" alt="">
                        <p class="acc-bitu">Acc</p>
                      </div>
                    </template>
                    <span>
                      <div>Tài khoản Vuihoc: {{ contact.childCustomer[indexChild].userName }}</div>
                      <div v-if="contact.childCustomer[indexChild].order">Đơn tạo gần nhất: {{ formatDateToolTips(contact.childCustomer[indexChild].order)}}</div>
                    </span>
                  </v-tooltip>
                </div>
              </div>
              </td>
              <!-- <td v-show="statusRowAttribute('mobile')">{{ _.get(contact, 'mobile', '') }}</td> -->
              <!-- <td v-show="statusRowAttribute('birthday')">{{ _.get(customer, 'birthday', '') }}</td> -->
              <td class="scroll-layout-left" :style="'left:' + sticky_birthday + 'px'"
                  v-show="statusRowAttribute('birthday')"
                  @dblclick="enableEditAttribute(contact, {contact: customer, index: index, e: $event, attr: 'birthday', indexChild: indexChild, id: customer.id, type: 'select', oldValue: customer.birthday})"
              >
              <!-- <td class="scroll-layout-left" :style="'left:' + sticky_birthday + 'px'"
                  v-show="statusRowAttribute('birthday')"
              > -->
                <span v-if="!contact.childCustomer[indexChild].editAttrs.birthday">{{ _.get(customer, 'birthday', '') }}</span>
                <common-select-year
                  v-if="contact.childCustomer[indexChild].editAttrs.birthday"
                  v-model="customer.birthday"
                  label="Năm sinh"
                  @input="onChangeAttribute(customer, 'birthday', index, indexChild, contact.id, $event)"
                />
              </td>
              <td v-show="statusRowAttribute('birthdayDescription')"
                @dblclick="enableEditAttribute(contact, {contact: customer, index: index, e: $event, attr: 'birthdayDescription', indexChild: indexChild, id: customer.id, oldValue: customer.birthdayDescription})"
                >
                <span v-if="!contact.childCustomer[indexChild].editAttrs.birthdayDescription">{{ _.get(contact.childCustomer[indexChild], 'birthdayDescription', '') }}</span>
                <input v-if="contact.childCustomer[indexChild].editAttrs.birthdayDescription"
                v-bind:id="'birthdayDescription_' + customer.id" type="text"
                style="width: 100%; height: 80%; padding-left: 5px"
                :value="customer.birthdayDescription"
                @change="onChangeAttribute(customer, 'birthdayDescription', index, indexChild, contact.id, $event)"/>
              </td>
              <td v-show="statusRowAttribute('productDescription')"
                @dblclick="enableEditAttribute(contact, {contact: customer, index: index, e: $event, attr: 'productDescription', indexChild: indexChild, id: customer.id, oldValue: customer.productDescription})"
                >
                <span v-if="!contact.childCustomer[indexChild].editAttrs.productDescription" style="word-break: break-word">{{ _.get(contact.childCustomer[indexChild], 'productDescription', '') }}</span>
                <input v-if="contact.childCustomer[indexChild].editAttrs.productDescription"
                v-bind:id="'productDescription_' + customer.id" type="text"
                style="width: 100%; height: 80%; padding-left: 5px"
                :value="customer.productDescription"
                @change="onChangeAttribute(customer, 'productDescription', index, indexChild, contact.id, $event)"/>
                <v-tooltip bottom v-if="_.get(contact.childCustomer[indexChild], 'customerData.doCapacityTest', []).length == 1">
                  <template v-slot:activator="{ on }">
                    <v-btn
                            v-if="_.get(contact.childCustomer[indexChild], 'customerData.doCapacityTest', []).length == 1"
                            class="btn-show-modal-count-interaction"
                           :href="_.get(contact.childCustomer[indexChild], 'customerData.doCapacityTest[0].url', '')"
                           target="_blank"
                           icon
                           small
                           color="info"
                           v-on="on"
                    >
                      <v-icon color="pink" class="icon-comment">mdi-file-document</v-icon>
                    </v-btn>
                  </template>
                  <span>Xem nhận xét kiểm tra năng lực</span>
                </v-tooltip>
                <!--             menu popover-->
                <template v-else-if="_.get(contact.childCustomer[indexChild], 'customerData.doCapacityTest', []).length > 1">
                  <v-menu
                      :close-on-content-click="false"
                      :nudge-width="0"
                      offset-x
                  >
                    <template v-slot:activator="{ on: menu, attrs }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                                class="btn-show-modal-count-interaction"
                                small
                                color="pink"
                                dark
                                v-bind="attrs"
                                v-on="{...tooltip, ...menu}"
                                icon
                            >
                              <v-icon color="pink" class="icon-comment">mdi-file-document</v-icon>
                            </v-btn>
                          </template>
                          <span>Xem nhận xét kiểm tra năng lực</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item
                          v-for="(item, index) in _.get(contact.childCustomer[indexChild], 'customerData.doCapacityTest', [])"
                          :key="index"
                      >
                        <a :href="item.url" target="_blank">{{item.name}}</a>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>

                <v-tooltip bottom v-if="contact.capacityAssessmentAt">
                  <template v-slot:activator="{ on }">
                    <v-icon color="blue" class="icon-comment" v-on="on">mdi-note-text</v-icon>
                  </template>
                  <span>Thi DGNL</span><br>
                  <span>{{ contact.capacityAssessmentAt | formatDateTime }}</span>
                </v-tooltip>
              </td>
              <!-- <td v-show="statusRowAttribute('capability')">{{ _.get(customer, 'capability', '') }}</td> -->
              <td v-show="statusRowAttribute('capability')"
                @dblclick="enableEditAttribute(contact, {contact: customer, index: index, e: $event, attr: 'capability', indexChild: indexChild, id: customer.id, oldValue: customer.capability})"
                >
                <span v-if="!contact.childCustomer[indexChild].editAttrs.capability">{{ _.get(contact.childCustomer[indexChild], 'capability', '') }}</span>
                <input v-if="contact.childCustomer[indexChild].editAttrs.capability"
                v-bind:id="'capability_' + customer.id" type="text"
                style="width: 100%; height: 80%; padding-left: 5px"
                :value="customer.capability"
                @change="onChangeAttribute(customer, 'capability', index, indexChild, contact.id, $event)"/>
              </td>

              <td v-show="statusRowAttribute('studyResult')"
              >

<!--                <span v-if=" _.get(contact.childCustomer[indexChild], 'isLoading', '')">Đang cập nhật ...</span>-->
<!--                <v-icon v-if=" _.get(contact.childCustomer[indexChild], 'isLoading', true)">md-progress-spinner</v-icon>-->

                <v-tooltip bottom v-if=" _.get(contact.childCustomer[indexChild], 'statusResultName', []).length">
                  <template v-slot:activator="{ on }">
                    <v-btn class="btn-show-modal-study-result"

                           @click="clickShowStudyResult(contact.childCustomer[indexChild])"
                           icon
                           small
                           color="info"
                           v-on="on"
                    >
                      <v-icon>mdi-book-open-variant</v-icon>
                    </v-btn>
                    <span class="custom-span-title-study-result pl-1">{{ _.get(contact.childCustomer[indexChild], 'statusResultName', '') }}</span>
                  </template>
                  <span>Kết quả học tập</span>
                </v-tooltip>

              </td>
              <td v-show="statusRowAttribute('schoolName')"
              >
                <span>{{_.get(customer, 'schoolName', '')}}</span>
              </td>
              <td v-show="statusRowAttribute('activeCode')"
              >
                <div v-if="customer.activeCode && customer.activeCode.length">
                  <span v-if="customer.activeCode.length === 1">{{customer.activeCode[0]}}</span>
                  <v-tooltip v-if="customer.activeCode.length > 1" bottom>
                    <template
                      v-slot:activator="{ on }"
                    >
                      <span v-on="on">{{customer.activeCode[0]}}, ...</span>
                    </template>
                    <div
                      v-for="(active, keyActive) in customer.activeCode"
                      :key="keyActive">
                      {{active}}<br>
                    </div>
                  </v-tooltip>
                </div>
              </td>
              <template
                v-for="(attribute, index) in rowAttributes.filter(data => data.object === 'child')"
              >
                <td
                  v-show="statusRowAttribute(attribute.name)"
                  :key="'coloumn_child_'+ index + '_' + indexChild"
                >{{_.get(customer, `${attribute.name}`, '')}}</td>
              </template>
            </tr>
          </template>
        </tbody>
        <tbody v-if="contacts.length == 0">
          <tr>
            <td colspan="10" class="scroll-layout-left" :style="'left:' + sticky_id">
              <common-no-result />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <modal-quick-view
      v-if="filterForm.openQuickView"
      :filter-form="filterForm"
      :dataContact="dataContact"
      :contactStatusList="contactStatusList"
      :users="usersContactAdvise"
      :contactQuickviewDetail="contactQuickviewDetail"
      :classListTutor="classListTutor"
      :classListDuo="classListDuo"
      :dataZalo="dataZalo"
    />
    <modal-quick-view-marketing
        v-if="filterForm.openQuickViewMarketing"
        :filter-form="filterForm"
        :dataContact="dataContact"
        :contactStatusList="contactStatusList"
        :users="users"
        :users-marketing="usersMarketing"
        :contactQuickviewDetail="contactQuickviewDetail"
        :dataZalo="dataZalo"
    />
    <modal-study-result
        v-if="filterForm.openStudyResult"
        :filterForm="filterForm"
        :dataStudyResult="dataStudyResult"
    />

    <v-dialog
        v-model="showMergeModal"
        max-width="500"
    >
      <v-card>
        <v-card-title class="font-weight-bold mb-0 d-flex justify-space-between">
          <span>Hãy nhập số chính để thực hiện gộp số</span>
          <v-btn
              color="default"
              @click="showMergeModal = false; mobileMerge = null"
              class="text-right"
              icon
              small
          >
            <v-icon aria-label="Close" style="position: unset">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <validation-observer v-slot="{ handleSubmit }">
          <v-card-text class="py-0">
            <validation-provider
                v-slot="{ errors }"
                class="mb-2 w-100"
                name="Số điện thoại"
                :rules="{ regex: regex.isVNPhoneMobile, required: true, is_not: dataForm.mobile }"
            >
              <v-text-field
                  v-model="mobileMerge"
                  :error-messages="errors"
                  color="primary"
                  class="i-cursor"
                  placeholder="Nhập sđt chính ..."
              />
            </validation-provider>
          </v-card-text>
          <v-card-actions class="text-center py-3">
            <v-spacer></v-spacer>
            <v-btn
                color="success"
                @click.prevent="handleSubmit(mergeContact)"
                height="30px"
            >
              Tiếp tục
            </v-btn>
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import * as moment from "moment";

import TokenService from "../../../helpers/token";
import ModalQuickView from "./ModalQuickView";
import ModalQuickViewMarketing from "./ModalQuickViewMarketing";
import ModalStudyResult from "./ModalStudyResult";
import handleSchedule from "@/mixins/handleSchedule";
import { showFbMessengerIcon } from "@/helpers/utils";
import RepositoryFactory from "../../../repositories/RepositoryFactory";
import DatetimePicker from "vuetify-datetime-picker/src/components/DatetimePicker";
import { userPositions , moduleTypes, moduleSchoolLevel, USER_NOT_SHOW_CONTACT_SOURCE} from '../../../helpers/constants';
import { maskedPhoneNumber } from '@/helpers/regex.js'
const ContactRepository = RepositoryFactory.get("contact");
const UserRepository = RepositoryFactory.get("user");
const TestManageRepository = RepositoryFactory.get("testManage");
var oldValue = "";
// var listUser = [];
// UserRepository.list({limit: 1000, page: 0}).then(res => {
//   if(res.success){
//     listUser = _.get(res, 'data');
//   }
// });
import { regex, CLASS_OF_STUDENT } from '../../../helpers/constants';
import CopyIconButton from "../../../components/common/CopyIconButton.vue";
export default {
  $_veeValidate: {
    validator: "new",
  },
  mixins: [handleSchedule],
  components: {
    ModalQuickView,
    ModalStudyResult,
    ModalQuickViewMarketing,
    DatetimePicker,
    CopyIconButton
},
  props: {
    filterForm: {
      type: Object,
      default: () => ({})
    },
    contacts: {
      type: Array,
      default: () => []
    },
    contactStatusList: {
      type: Array,
      default: () => []
    },
    rowAttributes: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    contactSources: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: () => 0
    },
    limit: {
      type: Number,
      default: () => 20
    },
    usersMarketing: {
      type: Array,
      default: () => []
    },
    usersContactAdvise: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      reRender:1,
      showConfirm: false,
      hasScrolled: false,
      dataContact: {},
      mobile: '',
      stickyColumn: ["childFullName", "mobile", "birthday"],
      sticky_id: '0px',
      sticky_checkbox: '',
      sticky_childFullName: '',
      sticky_mobile: '',
      sticky_birthday: '',
      oldPosition: 0,
      dataStudyResult: {},
      dialogModal: false,
      isCoppy: false,
      snackbar: false,
      objectSelect: 0,
      selectChild: null,
      nullDatetime: "",
      contactTutors: [],
      contactsFilter: [],
      fullNameChild: [],
      getMath: [],
      listObjects: [],
      pickTimeTest: null,
      pickTimeFilter: "--/--",
      pickHour: "--/--",
      objectMath: null,
      checked: [],
      myInput: [],
      enlishLink: null,
      valid: true,
      listTutors: [],
      getMathLink: null,
      getEnglishLink: null,
      subjectId: 1,
      ex5: false,
      englishRadio: false,
      snackbarTestLink: false,
      myMathlink: null,
      myEnglishlink: null,
      objectEnglish: null,
      grade: null,
      levelE: null,
      checkDisabled: false,
      checkDisabledEnglish: false,
      landscape: false,
      reactive: false,
      errorTime: false,
      user: {},
      userPositions,
      contactQuickviewDetail:null,
      listSubjects:null,
      showMergeModal: false,
      mobileMerge: null,
      dataForm: {},
      regex,
      classListTutor: [],
      classListDuo: [],
      CLASS_OF_STUDENT,
      dataZalo: {},
      moduleTypes,
      moduleSchoolLevel,
      USER_NOT_SHOW_CONTACT_SOURCE,
      userId: +TokenService.getId(),
    };
  },
  filters: {
    formatDateTime(value) {
        if(!value) {
            return '--'
        }
      return moment(value).format("HH:mm DD-MM-YYYY");
    },
  },
  watch: {
    contacts: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          // this.reRender++;
          this.contacts = newVal;
        }
      }
    },
    rowAttributes: {
      deep: true,

      handler(newVal, oldVal) {
        if (newVal.find(item => item.name == "childFullName").value && this.oldPosition > 0) {
          this.sticky_checkbox = parseInt(this.$refs.th_id.clientWidth)
          this.sticky_childFullName = (parseInt(this.$refs.th_checkbox.clientWidth) + this.sticky_checkbox)
          this.sticky_mobile = _.cloneDeep(this.oldPosition)
          this.sticky_birthday = parseInt(this.$refs.th_mobile[0].clientWidth) + this.sticky_mobile
        } else if (!newVal.find(item => item.name == "childFullName").value) {
          this.oldPosition = _.cloneDeep(this.sticky_mobile)
          this.sticky_checkbox = parseInt(this.$refs.th_id.clientWidth)
          this.sticky_mobile = parseInt(this.$refs.th_checkbox.clientWidth) + this.sticky_checkbox
          this.sticky_birthday = parseInt(this.$refs.th_mobile[0].clientWidth) + this.sticky_mobile
        }
      }
    }
  },
  created() {
    Bus.$on('calculate-sticky-contact-table-data', () => {
      this.$nextTick( () => {
        if (this.$refs.th_id) {
          this.sticky_checkbox = parseInt(this.$refs.th_id.clientWidth)
        }
        if (this.$refs.th_checkbox) {
          this.sticky_childFullName = parseInt(this.$refs.th_checkbox.clientWidth) + this.sticky_checkbox
        }
        if (this.$refs.th_childFullName && this.$refs.th_childFullName.length) {
          this.sticky_mobile = this.$refs.th_childFullName && this.$refs.th_childFullName.length ?
              parseInt(this.$refs.th_childFullName[0].clientWidth ) + this.sticky_childFullName
              : this.sticky_childFullName;
        }
        if (this.$refs.th_mobile && this.$refs.th_mobile.length) {
          this.sticky_birthday = parseInt(this.$refs.th_mobile[0].clientWidth) + this.sticky_mobile
        }
      })

    })
    Bus.$on('zalo-web-hook',data=>{
      let index = this.contacts.findIndex(cont => cont.id == data.contactId)
      if(index > -1) {
        this.contacts[index]['zuid'] = data.zuid
      }
    });
    Bus.$on('get-class-list-of-child', (customerId) => {
      this.getStudentClassList(customerId);
    });
    this.user = TokenService.getUser();
    Bus.$on('scroll-to-contact-row-index', () => {
      this.scrollToContactRowIndex()
    });
  },
  beforeDestroy() {
    Bus.$off('get-class-list-of-child');
    Bus.$off('scroll-to-contact-row-index');
  },
  mounted() {
    this.sticky_checkbox = parseInt(this.$refs.th_id.clientWidth)
    this.sticky_childFullName = parseInt(this.$refs.th_checkbox.clientWidth) + this.sticky_checkbox
    this.sticky_mobile = parseInt(this.$refs.th_childFullName[0].clientWidth) + this.sticky_childFullName
    this.sticky_birthday = parseInt(this.$refs.th_mobile[0].clientWidth) + this.sticky_mobile
  },
  computed: {
    ...mapState(['autoCallIndex','isCallWithBrandName', 'selectedCallOptions']),
    isShowCopyPhoneNumber() {
      const module = this.$store.state.listSchoolLevelDrawer.find((e) => e.id === this.filterForm.typeId) || {};
      const schoolLevel = _.get(module, 'schoolLevel', []).find((e) => e.id === this.filterForm.schoolLevelId) || {};
      if (this.filterForm.store === 'M' && _.get(module, 'name', '') === 'Tự học' && _.get(schoolLevel, 'name', '') === 'Tiểu học'){
        return false;
      }
      return true;
    },
    statusCallCenter() {
      return (
        this.checkAuthorization('call_center_read') ||
        this.checkAuthorization('call_center_view_all')
      );
    },
    countContactSelect() {
      return this.contacts.filter((dataContact) => dataContact.checkbox).length;
    },
    renderTextLink() {
      let textLink = "";
      if (this.getMathLink.length > 0) {
        textLink = this.getMathLink[0].textLink;
      }
      if (this.getEnglishLink.length > 0) {
        textLink = this.getEnglishLink[0].textLink;
      }
      return textLink;
    },
    // getSelectUser() {
    //   return listUser;
    // }
    isNormalCall(){
      const user = TokenService.getUser();
      return this.checkAuthorization('auto-call_read') || user.username === 'tructoi' || user.username === 'tructoi_caresoft' || user.username === 'Tructongdai_ODS' || user.callcenter_id == 1 || !this.isCallWithBrandName
    }
  },
  methods: {
    checkShowAtrribute(value) {
      if (value == 'contactSources' && this.filterForm.typeId == moduleTypes.TU_HOC && (this.filterForm.schoolLevelId == moduleSchoolLevel.TH || this.filterForm.schoolLevelId == moduleSchoolLevel.THCS) && !this.USER_NOT_SHOW_CONTACT_SOURCE.includes(this.userId)) {
        return false
      } else {
        return true
      }
    },
    showBitu(value){
      return /^\d+$/.test(value);
    },
    formatDateToolTips(value){
      if(!value) {
          return null
      }
        return moment(value).format("DD/MM/YYYY");
    },
    isMainAccount(str) {
      // Chuyển đổi chuỗi thành số
      const number = parseInt(str, 10);

      // Kiểm tra xem số đó có phải là số nguyên và chuỗi ban đầu không chứa ký tự không hợp lệ
      return Number.isInteger(number) && number.toString() === str;
    },
    maskedPhoneNumber,
    async checkCanDeleteCustomer(contactId,customerId){
      let res = await ContactRepository.checkCanDeleteCustomer(customerId);
      if(res.data.canRemove){
        this.clickDeleteCustomer(contactId, customerId)
      } else {
        this.$swal({
          text: res.data.message,
          type: 'warning',
          title: 'Thông báo !',
          icon: 'warning',
        })
      }
    },
    clickDeleteCustomer(contactId, customerId) {
      this.$swal({
        title: 'Xóa thông tin của Con',
        text: 'Bạn có thực sự muốn xoá ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy bỏ'
      }).then(async result => {
        if (result.value) {
          const loading = this.$loading.show();
          const response = await ContactRepository.deleteContactCustomer(customerId);
          loading.hide();
          if (response.error) {
            this.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: _.get(response, 'message', '')
            });
          } else {
            Bus.$emit('contact-list-filter', this.filterForm);
          }
        }
      });
    },
    getColorStatus(statusId) {
      const dataStatus = this.contactStatusList.find(
        dataStatus => dataStatus.id == statusId
      );
      return _.get(dataStatus, 'color', '');
    },
    async clickQuickView(contact) {
      this.classListTutor = [];
      this.classListDuo = [];
      this.contactQuickviewDetail = contact
      if (contact.mainId) {
        let self = this
        this.$swal({
          title: 'Số điện thoại đã được gộp vào contact ' + contact.phoneRelated[0] + '.<br>Vui lòng thực hiện các thao tác tại contact chính.',
          confirmButtonText: 'Xem contact chính',
          showCancelButton: true,
          cancelButtonText: 'Quay lại'
        }).then((res) => {
          if (res.value) {
            let routeData = self.$router.resolve({
              name: 'ContactDetail',
              params: {
                id: contact.mainId || 0
              }
            })
            window.open(routeData.href, '_blank')
          }
        })
      } else {
        const loading = this.$loading.show();
        const response = await ContactRepository.detail(contact.id);
        console.log(response,'response');
        loading.hide();
        this.dataContact = { ...contact };
        this.dataContact.beforeSupport = _.get(response, 'data.beforeSupport', null)
        this.dataContact.order = _.get(response, 'data.order', {})
        this.dataContact.appointment = _.get(response, 'data.appointment', {})
        this.dataContact.userMarketingName = _.get(response, 'data.userMarketingName', '')
        this.dataContact.customers = _.get(response, 'data.customers', [])
        const contactStatusOfContact = _.get(contact, 'contactStatus.type', [])
        if(contactStatusOfContact.length && contactStatusOfContact[0] == "M") {
          this.filterForm.openQuickViewMarketing = true;
          this.filterForm.openQuickView = false;
        } else {
          this.filterForm.openQuickView = true;
          this.filterForm.openQuickViewMarketing = false;
        }
        this.getStudentClassList(this.dataContact.childCustomer[0].vhUserId);
        this.userInteractiveZalo(this.dataContact.mobile)
        setTimeout(() => {
          $(`#customer-learning-0`).addClass("active");
        }, 200);
      }
      Bus.$emit('reload-interview')
    },
    scrollToContactRowIndex(){
      let ref = `contact-row-${this.autoCallIndex}`
      const [el] = this.$refs[ref]
      if(el){
        el.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
      }
    },
    statusRowAttribute(attributeName) {
      return (
        this.rowAttributes.findIndex(
          attribute => attribute.value && attribute.name == attributeName
        ) !== -1
      );
    },
    async clickExecuteCall(contact, phone) {
      if(this.isNormalCall){
        let user = TokenService.getUser()
        if (user.ext) {
          let data = {
            mobile: phone,
            showCreateAppointment: false,
            contactId: contact.id,
            callcenter_id: user.callcenter_id,
            mainId: contact.mainId,
            mainMobile: contact.phoneRelated[0],
            store: this.filterForm.store,
            contactCode: contact.code,
          }
          Bus.$emit('voice-call-show-popup', data)
        } else {
          this.$swal({
            title: 'Thông báo!',
            text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.'
          })
        }
      }else{
        let body = {
          contactId : contact.id,
          type: this.selectedCallOptions.type,
          brandnameCode: this.selectedCallOptions.brandnameCode ? this.selectedCallOptions.brandnameCode : null,
        }
        let ext = ''
        let password = ''
        let callcenter_id = ''
        let group_id = ''
        let res = await ContactRepository.getCallInfo(body)
        if (res && res.success){
          ext = res.data[0].ext;
          password = res.data[0].extPassword;
          callcenter_id = res.data[0].callcenterId;
          group_id = res.data[0].groupId;
        } else {
          if (_.get(res, 'errors.errorCode', null) == 4) {
            this.$swal({
              title: 'Thông báo!',
              text: _.get(res, 'errors.message', null)
            })
          } else {
            this.$swal({
              title: 'Thông báo!',
              text: 'Chưa có máy lẻ. Vui lòng liên hệ Sale Admin.'
            })
          }
          return
        }

        let data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: contact.id,
          callcenter_id: callcenter_id,
          mainId: contact.mainId,
          mainMobile: contact.phoneRelated[0],
          store: this.filterForm.store,
          groupId: group_id
        }
        if (callcenter_id == 1){
          await Bus.$emit('init-epa-call-center',ext, password, data);
        }else if (callcenter_id == 2){
          await Bus.$emit('init-care-soft-call-center', ext, data);
        }else if (callcenter_id == 4){
          await Bus.$emit('init-ods-call-center',ext, password, data);
        }
      }
    },
    clickNewAppointment(contact) {
      const contactDetail = {
        contactId: contact.id,
        mobile: contact.mobile,
        fullName: contact.contactFullName,
        contactType: contact.contactStatus.type,
        contactSources: contact.contactSources,
        mainId: contact.mainId,
        mainMobile: contact.phoneRelated[0],
        childCustomer: contact.childCustomer
      };
      Bus.$emit('appointment-show-form-from-contact', contactDetail);
    },
    onChangeCheckboxAll() {
      this.contacts.forEach(contact => {
        const contactTemp = contact;
        contactTemp.checkbox = this.filterForm.checkboxAll && !contact.mainId;
      });
    },
    clickContact(contactId) {
      let routeData = this.$router.resolve({
        name: 'ContactDetail',
        params: {
          id: contactId || 0
        }
      });
      window.open(routeData.href, '_blank')
    },
    contactStatusName(statusId) {
      const status = this.contactStatusList.find(
        status => status.id === statusId
      );
      return `${_.get(status, 'type', '').slice(-2)} - ${_.get(status, 'name', '')}`;
    },
    async enableEditAttribute(contactMain, options){
      if (contactMain.contactType == "sub") {
        this.$swal({
          title: 'Số điện thoại đã được gộp vào contact ' + contactMain.phoneRelated[0] + '.<br>Vui lòng thực hiện các thao tác tại contact chính.',
          confirmButtonText: 'Xem contact chính',
          showCancelButton: true,
          cancelButtonText: 'Quay lại'
        }).then((res) => {
          if (res.value) {
            let routeData = this.$router.resolve({
              name: 'ContactDetail',
              params: {
                  id: contactMain.mainId || 0
              }
            })
            window.open(routeData.href, '_blank')
          }
        })
      } else if(!this.checkAuthorization('lock-edit-attr-dashboard_read')) {
        const contact = _.get(options, 'contact', {});
        const index = _.get(options, 'index', 0);
        const e = _.get(options, 'e', {});
        const attr = _.get(options, 'attr', '');
        const type = _.get(options, 'type', 'input');
        const indexChild = _.get(options, 'indexChild', 0);
        const id = _.get(options, 'id', 0);
        oldValue = _.get(options, 'oldValue', '');
        if(typeof contact.editId == 'undefined'){
          this.contacts[index].oldValue = contact[attr];
        }
        else{
          this.contacts[index].childCustomer[indexChild].oldValue = contact[attr];
        }

        this.contacts[index].childCustomer[indexChild].editAttrs[attr] = true;
        const self = this;
        setTimeout(function(){
          if(type == 'input'){
            document.getElementById(attr + '_' + id).focus();
            document.getElementById(attr + '_' + id).click();
          }
          else{

          }
        }, 300);
      }
    },
    async onChangeAttribute(contact, attr, index, indexChild = 0, contactId = 0, e){

      if (attr == 'childFullName') {
        contact['fullName'] = e
      } else if (attr != 'birthday' && attr != 'contactSourcesList') {
        contact[attr] = e.target.value
      }
      const self = this;
      const dataUpdate = {};
      let customerId = (contact.customerUpdateId ? contact.customerUpdateId : contact.id);
      if(attr == 'childFullName'){
        dataUpdate['fullName'] = contact['fullName'];
      }
      else{
        dataUpdate[attr] = contact[attr];
      }
      if(attr == 'fullName' && !dataUpdate[attr].toString()){
        dataUpdate[attr] = contact.mobile;
        contact.fullName = contact.mobile;
      }
      if((attr == 'email' || attr == 'fullName' || attr == 'detailAddress') && contact.mainCustomerId){
        customerId = contact.mainCustomerId;
      }
      if(attr == 'contactSourcesList'){
        delete dataUpdate[attr];
        dataUpdate.contactId = contact.id;
        // dataUpdate.createdBy = contact.createdBy;
        dataUpdate.contactSourceIds = contact[attr];
      }
      else if(attr == 'userFullName'){
        delete dataUpdate[attr];
        dataUpdate.userId = contact.user.id;
        dataUpdate.statusId = contact.statusId;
        dataUpdate.customers = contact.customers;
        dataUpdate.isDeleted = 0;
      }
      const loader = this.$loading.show();

      var respond = null;
      if(attr == 'userFullName' && contactId){
        respond = await ContactRepository.updateContactUser([{contactId: contactId, userId: dataUpdate.userId}]);
        // Bus.$emit('contact-list-filter', this.filterForm);
      }
      else if(customerId){
        respond = await ContactRepository.updateCustomer(dataUpdate, customerId);
      }
      else if(contactId){
        dataUpdate.contactId = contactId;
        dataUpdate.position = 'child';
        respond = await ContactRepository.createCustomer(dataUpdate);
      }
      if (_.get(respond, 'success', false)) {
        loader.hide();
        self.$swal({
          type: 'success',
          title: 'Success',
          icon: 'success',
          timer: 800,
          showConfirmButton: false
        });
        self.contacts[index].childCustomer[indexChild].editAttrs[attr] = false;
        if(attr == 'contactSourcesList'){
          const getContact = await ContactRepository.detail(contactId);
          if(getContact.success){
            self.contacts[index].contactSources = _.get(getContact, 'data.contactSources', [])
              .map(contactSource => contactSource.name)
              .join(', ');
          }
        }
        else if(attr == 'userFullName'){
          const getContact = await ContactRepository.detail(contactId);
          if(getContact.success){
            self.contacts[index] = _.get(getContact, 'data', {});
          }
        }
      }
      else {
        loader.hide();
        if(typeof contact.editId == 'undefined'){
          this.contacts[index][attr] = oldValue;
        }
        else{
          this.contacts[index].childCustomer[indexChild][attr] = oldValue;
        }
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'errors[0].message', '')
        });
      }


      // const respond = await AddressRepository.provinces({ limit: 100 });
      // loader.hide();
      // if (_.get(respond, 'success', false)) {
      //   this.provinces = _.get(respond, 'data', []);
      // } else {
      //   this.$swal({
      //     type: 'error',
      //     title: 'Lỗi !',
      //     text: _.get(respond, 'message', '')
      //   });
      // }
    },
    showAppoimentAction(contact, phone) {
      const appointmentDetail = {
        id: contact.appointments.id,
        mainId: contact.mainId,
        mainMobile: contact.phoneRelated[0],
        customer: {
          contactId: contact.id
        },
        mobile: phone
      }
      Bus.$emit('appointment-show-form-from-action', appointmentDetail)
    },
    editAppointment (contact) {
      const appointmentDetail = {
        id: contact.appointments.id,
        mainId: contact.mainId,
        mainMobile: contact.phoneRelated[0],
        customer: {
          contactId: contact.id
        },
      }
      Bus.$emit('appointment-show-form-from-appointment', appointmentDetail)
    },
    checkContactSources(contactSources) {
      return showFbMessengerIcon(contactSources)
    },
    async clickShowStudyResult(child) {
      let tempChild = child;
      let params = {
        fullName: child.fullName,
        user_id: child.vhUserId ?? null
      }
      let res = await ContactRepository.getResultStudy(child.contactId, params);
      if (res.success && _.isArray(res.data) && res.data.length) {
        tempChild['performance'] = 'Phức tạp';
        tempChild['study_result'] = _.get(res, 'data[0].study_result', []);
        tempChild['study_result_multiple'] = _.get(res, 'data', []);
        tempChild['view_video_lesson'] = _.get(res, 'data.view_video_lesson', []);
      } else if(res.success) {
        tempChild['performance'] = _.get(res, 'data.performance', '');
        tempChild['study_result'] = _.get(res, 'data.study_result', []);
        tempChild['user_id'] = _.get(res, 'data.user_id', '');
        tempChild['view_video_lesson'] = _.get(res, 'data.view_video_lesson', []);
      }
      this.dataStudyResult = tempChild;
      this.filterForm.openStudyResult = true;
    },
    async checkTestLink(id) {
      this.checkDisabled = false;
      this.checkDisabledEnglish = false;
      this.myMathlink = null;
      this.myEnglishlink = null;
      this.isCoppy = false;
      this.objectSelect = 0;

      this.subjectId = 1
      let local_storage_tutor = localStorage.getItem("local_storage_tutor");
      if (local_storage_tutor) {
        local_storage_tutor = JSON.parse(local_storage_tutor);

        let tutor_choose = local_storage_tutor.filter((s) => {
          return s.id == id;
        });
        if (tutor_choose.length > 0) {
          tutor_choose.forEach((item) => {
            if (item.object_select === 0) {
              if ("link_math" in item) {
                this.myMathlink = item.link_math;
                this.pickTimeFilter = item.date;
                this.pickHour = item.hour;
                this.isCoppy = true;
              } else {
                this.myMathlink = "";
                this.isCoppy = false;
                this.pickTimeFilter = "";
                this.pickHour = "";
              }
            }

            if (item.object_select === 1) {
              if ("link_english" in item) {
                this.myEnglishlink = item.link_math;
                this.isCoppy = true;
                this.pickTimeFilter = item.date;
                this.pickHour = item.hour;
              } else {
                this.myEnglishlink = "";
                this.isCoppy = false;
                this.pickTimeFilter = "";
                this.pickHour = "";
              }
            }
          });
        }
      }
      let obj = [];
      let getMathLink = [];
      let getEnglish = [];
      const response = await TestManageRepository.getListTutor();
      let tutorContact = await response.data.data.filter((s) => {
        return s.customerId == id;
      });
      if (tutorContact.length > 0) {
        tutorContact[0].contactTutorPractice.forEach((i) => {
          if (i.subjectId == 1) {
            getMathLink.push({
              key: i.subjectId,
              textLink: i.testLink,
            });
          }
          if (i.subjectId == 2) {
            getEnglish.push({
              key: i.subjectId,
              textLink: i.testLink,
            });
          }
        });
      }
      this.getEnglishLink = getEnglish;
      this.getMathLink = getMathLink;
      // if (this.getMathLink[0].key) {
      //   this.isCoppy = true;
      // }
    },
    closeTutorModal() {
      this.objectEnglish = null;
      this.objectMath = null;
      this.myMathlink = null;
      this.myEnglishlink = null;
      this.selectChild = null;
      localStorage.removeItem("local_storage_tutor");
    },
    async helpBox(contact) {
      let inputSelectChild = document.querySelector(
        "#app > div:nth-child(6) > div > div.v-card.v-sheet.theme--light > div.v-card__text > div > span > div > div:nth-child(1) > span > div > div > div > div.v-input__slot > div.v-select__slot > div.v-select__selections > div"
      );
      if (inputSelectChild) {
        inputSelectChild.innerHTML = "";
      }
      this.nullDatetime = null;
      this.checkDisabled = false;
      this.checkDisabledEnglish = false;
      let timeInput = document.querySelector("#input-556");

      this.isCoppy = false;
      this.pickTimeTest = "";
      (this.pickTimeFilter = "--/--"),
        (this.pickHour = "--/--"),
        (this.nullDatetime = "");
      const getMaths = await TestManageRepository.getMath();
      const getListObjects = await TestManageRepository.getListObject();
      this.listSubjects = getListObjects.data
      this.listObjects = getListObjects.data.filter(
        (s) => s.alias == "tieng_anh"
      );
      this.getMath = getMaths.data;
      const response = await TestManageRepository.get(contact.id);
      this.contactTutors = response.data.contactTutors;

      const users = this.contacts.filter((s) => s.id === contact.id);
      this.contactsFilter = users;

      const fullNameChild = [];
      users.forEach((s) =>
        s.childCustomer.forEach((x) => {
          if (x.id) {
            fullNameChild.push({
              fullName: x.fullName,
              id: x.id,
            });
          }
        })
      );

      this.fullNameChild = fullNameChild;
    },
    clickOutside(){
      const label = document.querySelector(
        ".v-application--is-ltr .v-text-field .v-label.v-label--active"
      )
      if(label){
        label.style.visibility = 'hidden'
      }
    },
    checkTime() {
      if (
        moment(this.nullDatetime).format("YYYY-MM-DD HH:mm:ss") <
        moment().format("YYYY-MM-DD HH:mm:ss")
      ) {
        this.$swal({
          title: "Lỗi",
          text: "Bạn phải chọn thời gian lớn hơn hiện tại!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy bỏ",
        });
        this.errorTime = true;
      } else {
        this.errorTime = false;
      }

      const label = document.querySelector(
        ".v-application--is-ltr .v-text-field .v-label"
      );

      label.style.display = "none";
      const day = this.nullDatetime.getDate();
      const month = this.nullDatetime.getMonth() + 1;
      const year = this.nullDatetime.getFullYear();
      const hour = this.nullDatetime.getHours();
      const minutes = this.nullDatetime.getMinutes();
      const second = this.nullDatetime.getSeconds();
      const time =
        year +
        "-" +
        (month < 10 ? `0${month}` : month) +
        "-" +
        (day < 10 ? `0${day}` : day) +
        " " +
        (hour < 10 ? `0${hour}` : hour) +
        ":" +
        (minutes < 10 ? `0${minutes}` : minutes) +
        ":" +
        "00";
      this.pickTimeTest = time;
      this.pickTimeFilter =
        ` Thứ ${
          this.nullDatetime.getDay() == 0
            ? "CN"
            : this.nullDatetime.getDay() + 1
        }, ` +
        (day < 10 ? `0${day}` : day) +
        "/" +
        (month < 10 ? `0${month}` : month) +
        "/" +
        year;

      this.pickHour =
        (hour < 10 ? `0${hour}` : hour) +
        ":" +
        (minutes < 10 ? `0${minutes}` : minutes) +
        ":" +
        "00";
    },
    async createTutorLink() {
      this.isCoppy = true;
      let contactTutor = {
        contactId: this.contactsFilter[0].id,
        customerId: this.selectChild,
        subjectId: this.subjectId,
        // gradeId: this.objectMath.grade_id,
        // level: this.objectEnglish.id,
        appointmentTime: this.pickTimeTest,
      };

      if (this.objectMath && this.subjectId === 1) {
        contactTutor.gradeId = this.objectMath.grade_id;
        const response = await TestManageRepository.CreateLinkTest(
          contactTutor
        );
        let link_storage = "";
        if (response.message === "Item existed") {
          let test_link = response.errors.testLink;
          this.myMathlink = test_link;
          this.snackbarTestLink = true;
          this.checkDisabled = true;
          link_storage = test_link;
        }
        if (response.success) {
          let test_link = response.data.contactTutorPractice.testLink;
          this.myMathlink = test_link;
          this.grade = response.data.contactTutorPractice.grade;
          this.checkDisabled = true;
          link_storage = test_link;
        }
        let data_storage = {
          id: this.selectChild,
          link_math: link_storage,
          object_select: this.objectSelect,
          date: this.pickTimeFilter,
          hour: this.pickHour,
        };
        let local_storage_tutor = localStorage.getItem("local_storage_tutor");
        if (local_storage_tutor) {
          local_storage_tutor = JSON.parse(local_storage_tutor);
          local_storage_tutor.push(data_storage);
          localStorage.setItem(
            "local_storage_tutor",
            JSON.stringify(local_storage_tutor)
          );
        } else {
          local_storage_tutor = [];
          local_storage_tutor.push(data_storage);
          localStorage.setItem(
            "local_storage_tutor",
            JSON.stringify(local_storage_tutor)
          );
        }
      }
      if (this.objectEnglish && this.subjectId === this.listSubjects[1].id) {
        contactTutor.level = this.objectEnglish;
        const response = await TestManageRepository.CreateLinkTest(
          contactTutor
        );
        let link_storage = "";
        if (response.message === "Item existed") {
          this.myEnglishlink = response.errors.testLink;
          link_storage = response.errors.testLink;
          this.snackbarTestLink = true;
          this.checkDisabledEnglish = true;
        }
        if (response.success) {
          this.myEnglishlink = response.data.contactTutorPractice.testLink;
          link_storage = response.data.contactTutorPractice.testLink;
          this.levelE = response.data.contactTutorPractice.level;
          this.checkDisabledEnglish = true;
        }

        let data_storage = {
          id: this.selectChild,
          link_english: link_storage,
          object_select: this.objectSelect,
          date: this.pickTimeFilter,
          hour: this.pickHour,
        };
        let local_storage_tutor = localStorage.getItem("local_storage_tutor");
        if (local_storage_tutor) {
          local_storage_tutor = JSON.parse(local_storage_tutor);
          local_storage_tutor.push(data_storage);
          localStorage.setItem(
            "local_storage_tutor",
            JSON.stringify(local_storage_tutor)
          );
        } else {
          local_storage_tutor.push(data_storage);
          localStorage.setItem(
            "local_storage_tutor",
            JSON.stringify(local_storage_tutor)
          );
        }
      }
    },
    checkMath(data) {
      this.objectMath = data;
    },
    checkEnglish(data) {
      this.objectEnglish = data.id;
    },
    coppyText() {
      this.snackbar = true;
      if (this.objectMath) {
        navigator.clipboard.writeText(this.myMathlink);
      }
      if (this.objectEnglish) {
        navigator.clipboard.writeText(this.myEnglishlink);
      }
    },
    checkLinkEnglish(data) {
      this.objectSelect = 1;
      this.subjectId = this.listSubjects[1].id;
      this.isCoppy = false;
      let local_storage_tutor = localStorage.getItem("local_storage_tutor");
      if (local_storage_tutor) {
        local_storage_tutor = JSON.parse(local_storage_tutor);

        let tutor_choose = local_storage_tutor.filter((s) => {
          return s.id == this.selectChild;
        });
        if (tutor_choose.length > 0) {
          tutor_choose.forEach((item) => {
            // if(this.objectSelect === 0) {
            //    if ("link_math" in item) {
            //     this.myMathlink = item.link_math;
            //     this.isCoppy = true;
            //   } else {
            //      this.myMathlink = '';
            //     this.isCoppy = false;
            //   }
            // }

            if (item.object_select === 1) {
              if ("link_english" in item) {
                this.myEnglishlink = item.link_english;
                this.isCoppy = true;
                this.pickTimeFilter = item.date;
                this.pickHour = item.hour;
              } else {
                this.myEnglishlink = "";
                this.isCoppy = false;
                this.pickTimeFilter = "";
                this.pickHour = "";
              }
            }
          });
        }
      }
      // if (!this.myEnglishlink) {
      //   this.isCoppy = false;
      // } else {
      //   this.isCoppy = true;
      // }
    },
    checkObjectMath() {
      this.objectSelect = 0;
      this.subjectId = 1;
      this.isCoppy = false;
      let local_storage_tutor = localStorage.getItem("local_storage_tutor");
      if (local_storage_tutor) {
        local_storage_tutor = JSON.parse(local_storage_tutor);

        let tutor_choose = local_storage_tutor.filter((s) => {
          return s.id == this.selectChild;
        });
        if (tutor_choose.length > 0) {
          tutor_choose.forEach((item) => {
            if (item.object_select === 0) {
              if ("link_math" in item) {
                this.myMathlink = item.link_math;
                this.isCoppy = true;
                this.pickTimeFilter = item.date;
                this.pickHour = item.hour;
              } else {
                this.myMathlink = "";
                this.isCoppy = false;
                this.pickTimeFilter = "";
                this.pickHour = "";
              }
            }

            //  if(this.objectSelect === 1) {
            //    if ("link_english" in item) {
            //     this.myEnglishlink = item.link_math;
            //     this.isCoppy = true;
            //   } else {
            //      this.myEnglishlink = '';
            //     this.isCoppy = false;
            //   }
            // }
          });
        }
      }
      // if (!this.myMathlink) {
      //   this.isCoppy = false;
      // } else {
      //   this.isCoppy = true;
      // }
    },
    closeTutorTest() {
      this.nullDatetime = null;
      this.selectChild = null;
      this.dialogModal = false;
      this.pickTimeFilter = null;
      this.pickTimeFilter = "--/--";
      this.pickHour = "--/--";
      this.englishRadio = null;
      this.ex5 = null;
    },
    unmergeContact(contact) {
      this.dataForm = _.cloneDeep(contact)

      let title = ''
      if (contact.contactType == 'main') {
        title = "Xác nhận bỏ gộp contacts " + contact.phoneRelated.join(", ") + "<br>vào contact " + contact.mobile
      } else if (contact.contactType == 'sub') {
        title = "Xác nhận bỏ gộp contact " + contact.mobile + "<br>vào contact " + contact.phoneRelated[0]
      }
      this.$swal({
        title: title,
        confirmButtonText: 'Đồng ý',
        showCancelButton: true,
        cancelButtonText: 'Hủy',
        width: '500px'
      }).then(async (res) => {
        if (res.value) {
          let params = {
            contact_id: contact.id,
            contact_type: contact.contactType
          }
          let response = await ContactRepository.unmergeContact(params)
          if (response.success) {
            this.$swal({
              title: _.get(response, 'data', 'Bỏ gộp contact thành công'),
              confirmButtonText: 'Đồng ý',
              timer: 1000
            })
            Bus.$emit('contact-list-filter', this.filterForm);
          } else {
            this.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: _.get(response, 'message', '')
            })
          }
        }
      })
    },
    async mergeContact() {
      let self = this
      this.$swal({
            title: 'Xác nhận gộp contact ' + self.dataForm.mobile + '<br>vào contact ' + self.mobileMerge,
            confirmButtonText: 'Đồng ý',
            showCancelButton: true,
            cancelButtonText: 'Hủy'
          },
      ).then(async (res) => {
        if(res.value) {
          let params = {
            sub_contact_id: self.dataForm.id,
            main_phone: self.mobileMerge
          }
          let response =  await ContactRepository.mergeContact(params)
          if (response.success) {
            self.showMergeModal = false
            self.mobileMerge = ''
            this.$swal({
              title: _.get(response, 'data', 'Gộp contact thành công'),
              confirmButtonText: 'Đồng ý',
              timer: 1000
            })
            Bus.$emit('contact-list-filter', this.filterForm);
          } else {
            if (response.status == 500) {
              self.$swal({
                    title: 'Contact ' + self.mobileMerge + ' đã được gộp vào contact ' + response.errors.id + '.<br>Bạn có muốn gộp vào contact ' + response.errors.id + '?',
                    confirmButtonText: 'Đồng ý',
                    showCancelButton: true,
                    cancelButtonText: 'Hủy'
                  },
              ).then(async (res) => {
                if(res.value) {
                  let params = {
                    sub_contact_id: self.dataForm.id,
                    main_phone: response.errors.id
                  }
                  let response2 =  await ContactRepository.mergeContact(params)
                  if (response2.success) {
                    self.showMergeModal = false
                    self.mobileMerge = ''
                    this.$swal({
                      title: _.get(response2, 'data', 'Gộp contact thành công'),
                      confirmButtonText: 'Đồng ý',
                      timer: 1000
                    })
                    Bus.$emit('contact-list-filter', this.filterForm);
                  } else {
                    self.$swal({
                      type: 'error',
                      title: 'Lỗi !',
                      text: _.get(response2, 'message', '')
                    })
                  }
                }
              })
            } else {
              self.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(response, 'message', '')
              })
            }
          }
        }
      })
    },
    preMergeContact(contact) {
      this.dataForm = _.cloneDeep(contact)
      this.showMergeModal = true;
      this.dataForm = contact
    },
    async getStudentClassList(customerId) {
      const params = {
        'obj': 'tutor-routine-student',
        'filters[contact_id]': this.dataContact.id,
        'filters[lms_core_user_id]': customerId ? customerId : 'null',
        'attrs': [
          'name','number_lessons_passed','status_name','class_start_time','class_schedule','number_lessons',
          'status_color', 'vh_class_type', 'live_class_name', 'join_date', 'learn_again_time'
        ]
      }
      let res = await ContactRepository.getStudentClassList(params)
      if(res.success) {
        let newData = res.data;
        if (newData.length) {
          newData = newData.map(i => {
            return {
              ...i,
              class_schedule: JSON.parse(i.class_schedule),
            }
          });
        }
        this.classListTutor = newData.filter(i => i.vh_class_type === CLASS_OF_STUDENT.GIA_SU);
        this.classListDuo = newData.filter(i => i.vh_class_type === CLASS_OF_STUDENT.DUO);
      }
    },
    async userInteractiveZalo(mobile) {
      if(this.checkAuthorization('call-zalo_read')) {
        const res = await ContactRepository.userInteractiveZalo(mobile)
        this.dataZalo = _.get(res, 'data', {})
      }
    }

  },
};
</script>

<style scoped>
.table-contact tbody tr {
  height: 50px;
}
.table-contact table {
  border: 1px solid #d2d2d2;
}
.table-contact table .bg-hover:hover .child-table td:last-child {
  background: #e0e0e0;
}
.table-contact table .bg-hover:hover tr .scroll-layout-left {
  background: #e0e0e0;
}
.table-contact table .in-call tr {
  background: #90EE90;
}
.table-contact table .in-call tr .scroll-layout-left{
  background: #90EE90;
}
.table-contact table .calling tr {
  background: #FA8072;
}
.table-contact table .calling tr .scroll-layout-left{
  background: #FA8072;
}
.table-contact thead tr {
  height: 35px;
}
.table-contact thead th {
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
}
.table-contact thead th:last-child {
  border-right: 0;
}
.table-contact thead .th-id {
  min-width: 50px;
}
.table-contact .child-table td:last-child {
  border-right: 1px solid #d2d2d2;
}
.table-contact .child-table:hover {
  background: rgba(0, 0, 0, 0.11) !important;
}
.table-contact td {
  position: relative;
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
  color: #000000;
}
.table-contact td:last-child {
  border-right: 0;
}
.table-contact .table-layout-checkbox {
  position: relative;
}
.table-contact .table-layout-checkbox .v-input--selection-controls__input {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.v-data-table td {
  font-weight: 400;
  padding: 12px 8px;
  color: #444;
}


/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  text-align: left;
  font-size: 15px !important
}

tbody .action-cell {
  text-align: center;
}

tbody .tr-numerical-order {
  text-align: center;
}

thead th {
  height: 30px;
}

/deep/ .table-layout-checkbox .v-input--selection-controls__input {
  z-index: 1;
}
/deep/.th_childFullName {
  min-width: 170px;
  z-index: 10 !important;
}
/deep/.th_parentFullName {
  min-width: 170px;
}
/deep/.th_description {
  min-width: 200px;
}
/deep/.th_user {
  min-width: 170px;
}
/deep/.th_email {
  min-width: 150px;
}
/deep/.th_detailAddress {
  min-width: 250px;
}

/deep/ .th_productDescription {
  max-width: 250px;
}

/deep/ .th_numberOfCall {
  max-width: 20px;
}

/deep/ .th_appointment {
  min-width: 200px;
}

.appointment-time-wrapper {
  padding: 2px 0px;
  border: thin solid #A9A9A9;
  border-radius: 5px;
  cursor: pointer;
  min-width: 140px;
}
.custom-span-title-study-result {
  color: black;
  font-size: 13px !important;
  text-transform: none !important;
}
/deep/ .btn-show-modal-study-result span.v-btn__content {
  justify-content: normal !important;
}
.icon-comment {
  margin-left: 5px;
}
.btn-show-modal-count-interaction {
  position: absolute;
  top: 20%;
  right: 0%;
}

/deep/ .v-text-field--is-booted .v-input__control .v-input__slot {
  border: 1px solid #d9dbe9 !important;
  height: 40px !important;
  padding: 0 12px !important;
  border-radius: 4px !important;
}
/deep/ .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #d9dbe9 !important;
}
/deep/ .v-text-field--is-booted {
  padding-top: unset !important;
  margin-top: unset !important;
}
/deep/
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  border: 1px !important;
}
.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}
.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}
.ch-tag-trial {
  color: #F2994A;
  border: 1px solid #F2994A;
}
.v-tag-trial {
  color: #4F4F4F;
  border: 1px solid #4F4F4F;
}
@media screen and (max-width: 767px) {
  /deep/ .scroll-layout-left {
    position: unset !important;
  }
  /deep/ .th_mobile, .th_birthday, .th_childFullName, .th_checkbox, .th-id {
    position: sticky !important;
    left: unset !important;
  }
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: unset;
}
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background: #94bdf6 !important;
}
.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 8px !important;
}
.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}
.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}
.ch-tag-trial {
  color: #f2994a;
  border: 1px solid #f2994a;
}
.v-tag-trial {
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
}
</style>
<style lang="scss" >
.acc-bitu {
    width: 20px;
    height: 14px;
    border-radius: 4px;
    background-color: #4F8BFF;
    color: #fff;
    text-align: center;
    line-height: 14px;
    font-weight: 500;
    font-size: 8px;
    padding: 0 !important;
    margin: 0 !important;
}
.tool-tips-bitu{
  position: relative;
  img {
    position: absolute;
    top: -90%;
    left: 16%;
  }
}
</style>
